import './styles/Events.scss';
import { Events_PageMap, EventCategory_CategoryTypeMap, Events_PublicBeneficiaryMode, Events_SortModeMap, MemberUser_SalutationMap, EventRegistration_DietaryOptionsMap, EventRegistration_HRDClaimStatusMap, System_DeviceOrientationMap } from '../../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect } from 'react';
import { AppContext, ExAppContext } from '../../Context';
import { MemberUser_TypeMap } from '../../assets/keyMap';
import { IonDateString, IonDateFormat, IonDate } from '../../components/IonDate';
import { useHistory, useLocation } from 'react-router';
import { Country } from 'country-state-city';
import { Toast } from '@capacitor/toast';
import { isPlatform } from '@ionic/react';
import jsPDF from 'jspdf';
import { Browser } from '@capacitor/browser';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import OpenSansBase64 from '../../assets/base64s/openSans';
import { Camera, CameraResultType } from '@capacitor/camera';
import { DebugLogger as dlog } from '../../components/Logger';

//components
import Checker from '../../components/Checker';
import SelectionBox from '../../components/SelectionBox';
import ToggleSlider from '../../components/ToggleSlider';
import ImagePreviewer from '../../components/ImagePreviewer';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//classes
import Event from '../../exClasses/event';
import SelectionList from '../../classes/selectionList';
import MemberUser from '../../classes/memberUser';
import EventCategory from '../../exClasses/eventCategory';
import EventFee from '../../exClasses/eventFee';
import PublicUser from '../../exClasses/publicUser';
import MemberType from '../../exClasses/memberType';
import EventRegistration from '../../exClasses/eventRegistration';

//handlers
import SwipeOverscrollHandler from '../../handlers/SwipeOverscrollHandler';

//mui icons
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import VerifiedIcon from '@mui/icons-material/Verified';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import FeedIcon from '@mui/icons-material/Feed';

//graphics
// import PPKMLogo from '../../assets/images/logos/ppkmLogo.jpg';
import DefaultImage from '../../assets/images/general/defaultImage.jpg';
import { publicDecrypt } from 'crypto';
import { unstable_toUnitless } from '@mui/material';


class EventRegisteredParticipant {
    name: string = '';
    email: string = '';
    nric: string = '';
    phone: string = '';
}
class IdentificationDocument {
    ic_fileName: string = '';
    ic_base64String: string = '';
    passport_filaName: string = '';
    passport_base64String: string = '';

    constructor(
        ic_fileName: string,
        ic_base64String: string,
        passport_filaName: string,
        passport_base64String: string
    ) {
        this.ic_fileName = ic_fileName;
        this.ic_base64String = ic_base64String;
        this.passport_filaName = passport_filaName;
        this.passport_base64String = passport_base64String;
    }
}

const nonstate = {
    // pageMap: {
    //     DISCOVER: 0,
    //     DETAILS: 1,
    //     JOIN: 2,
    //     PAYMENT: 3
    // }, ---move to keymap
    eventFetchBatchSize: 10,
    // salutationSelectionList: [
    //     { key: MemberUser_SalutationMap['Mr'].toString(), value: 'Mr' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Mrs'].toString(), value: 'Mrs' } as SelectionList,
    //     { key: MemberUser_SalutationMap['Ms'].toString(), value: 'Ms' } as SelectionList
    //     // { key: MemberUser_SalutationMap['Dato'].toString(), value: 'Dato' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Tan Sri'].toString(), value: 'Tan Sri' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Puan Sri'].toString(), value: 'Puan Sri' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Datuk Seri'].toString(), value: 'Datuk Seri' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Datin Seri'].toString(), value: 'Datin Seri' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Datuk'].toString(), value: 'Datuk' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Datin'].toString(), value: 'Datin' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Dr'].toString(), value: 'Dr' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Miss'].toString(), value: 'Miss' } as SelectionList,
    //     // { key: MemberUser_SalutationMap['Others'].toString(), value: 'Others' } as SelectionList
    // ] as SelectionList[],
    dietaryOptionSelectionList: [
        { key: EventRegistration_DietaryOptionsMap['No Restrictions'].toString(), value: 'No Restrictions' },
        { key: EventRegistration_DietaryOptionsMap['Vegetarian'].toString(), value: 'Vegetarian' }
        // { key: EventRegistration_DietaryOptionsMap['Vegan'].toString(), value: 'Vegan' },
        // { key: EventRegistration_DietaryOptionsMap['Pescatarian'].toString(), value: 'Pescatarian' },
        // { key: EventRegistration_DietaryOptionsMap['Halal'].toString(), value: 'Halal' },
        // { key: EventRegistration_DietaryOptionsMap['Kosher'].toString(), value: 'Kosher' },
        // { key: EventRegistration_DietaryOptionsMap['Jain'].toString(), value: 'Jain' }
    ] as SelectionList[],
    controlledImgSize: 780
}

interface Props {

}

const Events: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState(Events_PageMap.UPCOMING);
    const [preSearchString, SetPreSearchString] = useState('');
    const [upcomingEvents, SetUpcomingEvents] = useState([] as Event[]);
    const [pastEvents, SetPastEvents] = useState([] as Event[]);
    const [eventFetchCounts, SetEventFetchCounts] = useState<any>({ upcoming: 0, past: 0 }); //for batch fetching, total fetched = eventFetchCounts * nonstate.eventFetchBatchSize
    const [selectionList_countryCode, SetSelectionList_countryCode] = useState([] as SelectionList[]);
    const [selectionList_eventCategory, SetSelectionList_eventCategory] = useState<SelectionList[]>([] as SelectionList[]);
    const [currentSelectedEvent, SetCurrentSelectedEvent] = useState<Event>({} as Event);
    const [currentSelectedEventFee, SetCurrentSelectedEventFee] = useState({} as EventFee);
    const [eventRate, SetEventRate] = useState<number>(0);
    const [shouldShowAddPublicParticipantMenu, SetShouldShowAddPublicParticipantMenu] = useState<boolean>(false);
    const [filter_searchString, SetFilter_searchString] = useState('');
    const [filter_eventCategory, SetFilter_eventCategory] = useState('');
    const [selectedEventRegistrations, SetSelectedEventRegistrations] = useState([] as EventRegistration[]);
    const [shouldShowDietaryMenu, SetShouldShowDietaryMenu] = useState(false);
    const [shouldShowUploadIdentificationDocumentsMenu, SetShouldShowUploadIdentificationDocumentsMenu] = useState(false);
    //states form vars
    //billing info
    const [newBillingName, SetNewBillingName] = useState('');
    const [newBillingAddress, SetNewBillingAddress] = useState('');
    const [newEInvoicePin, SetNewEInvoicePin] = useState('');
    //contact person info
    const [newContactSalutation, SetNewContactSalutation] = useState('Mr');
    const [newContactOtherSalutation, SetNewContactOtherSalutation] = useState('');
    const [newContactName, SetNewContactName] = useState('');
    const [newContactEmail, SetNewContactEmail] = useState('');
    const [newCountryCode, SetNewCountryCode] = useState('60');
    const [newContactPhone, SetNewContactPhone] = useState('');
    const [newContactOfficeNo, SetNewContactOfficeNo] = useState('');
    const [newHRDClaimStatus, SetNewHRDClaimStatus] = useState(EventRegistration_HRDClaimStatusMap.NO_HRD_CLAIM);
    //participants info
    //payment info
    const [newMemberSelected, SetNewMemberSelected] = useState<boolean[]>([] as boolean[]);
    const [newPublicParticipants, SetNewPublicParticipants] = useState<PublicUser[]>([] as PublicUser[]);
    const [newPublicUserSalutation, SetNewPublicUserSalutation] = useState<string>('Mr');
    const [newPublicUserFullName, SetNewPublicUserFullName] = useState<string>('');
    const [newPublicUserIC, SetNewPublicUserIC] = useState<string>('');
    const [newPublicUserEmail, SetNewPublicUserEmail] = useState<string>('');
    const [newPublicUserPhone, SetNewPublicUserPhone] = useState<string>('');
    const [newPublicUserDesignation, SetNewPublicUserDesignation] = useState<string>('');
    const [newPublicUserRPMNo, SetNewPublicUserRPMNo] = useState<string>('');
    // const [newMemberRegistered, SetNewMemberRegistered] = useState<IndividualMember[]>([] as IndividualMember[]);
    // const [memberUsers, SetMemberUsers] = useState<MemberUser[]>([] as MemberUser[]); ---deprecated to use exAppContext.membershipUsers
    // const [isRegistered, SetIsRegistered] = useState([] as boolean[]); ---deprecated
    const [eventTotalParticipants, SetEventTotalParticipants] = useState(0);
    const [upcomingEventsAltImgsErr, SetUpcomingEventsAltImgsErr] = useState([] as boolean[]);
    const [pastEventsAltImgsErr, SetPastEventsAltImgsErr] = useState([] as boolean[]);
    const [detailsImgErr, SetDetailsImgErr] = useState(false);
    const [newMemberDietaryOptions, SetNewMemberDietaryOptions] = useState([] as number[]);
    const [newPublicDietaryOptions, SetNewPublicDietaryOptions] = useState([] as number[]);
    const [newMemberDocs, SetNewMemberDocs] = useState<IdentificationDocument[]>([] as IdentificationDocument[]);
    const [newPublicDocs, SetNewPublicDocs] = useState<IdentificationDocument[]>([] as IdentificationDocument[]);
    //states - for documents upload
    const [uploadMemberNricCount, SetUploadMemberNricCount] = useState(-1);
    const [uploadMemberPassportCount, SetUploadMemberPassportCount] = useState(-1);
    const [uploadPublicNricCount, SetUploadPublicNricCount] = useState(-1);
    const [uploadPublicPassportCount, SetUploadPublicPassportCount] = useState(-1);
    //refs - objects
    const eventScrollRef = useRef<any>(null);
    //refs - vars
    const prevPageRef = useRef<number>(-1);
    const pageRef = useRef<number>(page);
    const upcomingEventsAltImgsErrRef = useRef<boolean[]>(upcomingEventsAltImgsErr);
    const pastEventsAltImgsErrRef = useRef<boolean[]>(pastEventsAltImgsErr);
    const eventScrollCheckRef = useRef<boolean>(true);
    const pastEventsBatchFetchCountRef = useRef<number>(0);
    //refs - vars - for image loading
    const canvasRef = useRef<HTMLCanvasElement>();
    const imageRef = useRef(new Image());
    const newMemberDocsRef = useRef<IdentificationDocument[]>(newMemberDocs);
    const newPublicDocsRef = useRef<IdentificationDocument[]>(newPublicDocs);
    const eventRegistrationIDRef = useRef<string>('');
    const uploadMemberNricCountRef = useRef(-1);
    const uploadMemberPassportCountRef = useRef(-1);
    const uploadPublicNricCountRef = useRef(-1);
    const uploadPublicPassportCountRef = useRef(-1);

    //refs - actions
    const pastEventScrollActionRef = useRef<any>(() => {
        if (eventScrollCheckRef.current) {
            const scrollPosition = eventScrollRef.current.scrollTop;
            const containerHeight = eventScrollRef.current.clientHeight;
            const scrollableHeight = eventScrollRef.current.scrollHeight;

            if (scrollPosition + containerHeight >= scrollableHeight) {
                //fetch 
                pastEventsBatchFetchCountRef.current += 1;
                databaseInterfaceController.Queue('fetchPastEventsByBatch', [
                    ['fetchPastEventsByBatch', 'true'],
                    ['dateNow', IonDateString(new Date())],
                    ['offset', pastEventsBatchFetchCountRef.current * nonstate.eventFetchBatchSize],
                    ['limit', nonstate.eventFetchBatchSize]
                ]);

                //disable and enable scrollCheck in later to prevent dupplication callout
                //the block will be revert back once fetch successfull
                eventScrollCheckRef.current = false;
            }
        }
    });

    //router objs
    const history = useHistory();
    const location = useLocation();

    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    useEffect(() => {
        dlog('EventsTest: ' + JSON.stringify(appContext.databaseActionModeQueue));
    }, [appContext.databaseActionModeQueue]);

    //initialization
    useEffect(() => {
        //initialize countryCodeSelectionList
        InitializeCountryCodesSelectionList();
        //initialize salutation list

        return(() => {
            prevPageRef.current = -1;
        });
    }, []);

    //watch  for locationPathname auto navigate to current/past page
    useEffect(() => {
        if (location.pathname.includes('/Past')) {
            pageRef.current = Events_PageMap.PAST;
            SetPage(pageRef.current);
        }

        const pathNameArr = location.pathname.split('/');
        if (location.pathname.includes('/Events') && pathNameArr.length == 3) {
            if (parseInt(pathNameArr[2]) == Events_PageMap.PAST) {
                pageRef.current = Events_PageMap.PAST;
            } else {
                pageRef.current = Events_PageMap.UPCOMING;
            }
            SetPage(pageRef.current);
        }
        if (location.pathname.includes('/Events') && pathNameArr.length == 4) {
            databaseInterfaceController.Queue('fetchEventByID', [
                ['fetchEventByID', 'true'],
                ['eventID', pathNameArr[3]]
            ]);
        }
    }, [location.pathname]);

    //watch for eventCategories update filterSelectionList
    useEffect(() => {
        const eventCategorySelectionList = [{ key: '', value: 'all categories' }] as SelectionList[];
        exAppContext.eventCategories.map((eventCategory: EventCategory) => {
            if (eventCategory.event_category_type != EventCategory_CategoryTypeMap.MEETING)
                eventCategorySelectionList.push({ key: eventCategory.event_categoryID, value: eventCategory.event_category_name } as SelectionList);
        });
        SetSelectionList_eventCategory([...eventCategorySelectionList]);
    }, [exAppContext.eventCategories]);

    //watch for events update upcomingEvents
    useEffect(() => {
        let events = [] as Event[];
        //by seting sortmode ascending, nearer events will be shown on top
        switch (page) {
            case Events_PageMap.UPCOMING:
                events = upcomingEvents;
                events = SortEventsByDate(events, Events_SortModeMap.ASCENDING);
                if (JSON.stringify(events) != JSON.stringify(upcomingEvents))
                    SetUpcomingEvents([...events]);
                break;
            case Events_PageMap.PAST:
                events = pastEvents;
                events = SortEventsByDate(events, Events_SortModeMap.DESCENDING);
                if (JSON.stringify(events) != JSON.stringify(pastEvents))
                    SetPastEvents([...events]);
                break;
        }

        //reset altImgsErr
        upcomingEventsAltImgsErrRef.current = [];
        upcomingEvents.map((event: Event) => {
            upcomingEventsAltImgsErrRef.current.push(false); //no errors
        });
        SetUpcomingEventsAltImgsErr([...upcomingEventsAltImgsErrRef.current]);

        pastEventsAltImgsErrRef.current = [];
        pastEvents.map((event: Event) => {
            pastEventsAltImgsErrRef.current.push(false); //no errors
        });
        SetPastEventsAltImgsErr([...pastEventsAltImgsErrRef.current]);
    }, [upcomingEvents, pastEvents]);

    //watch for currentSelectedEventUpdated
    useEffect(() => {
        if (Object.keys(currentSelectedEvent).length > 0) {
            pageRef.current = Events_PageMap.DETAILS;
            SetPage(pageRef.current);

            //fetch event fee
            databaseInterfaceController.Queue('fetchEventFee_eventID_memberTypeID', [
                ['fetchEventFee_eventID_memberTypeID', 'true'],
                ['eventID', currentSelectedEvent.eventID],
                ['member_typeID', exAppContext.membership.member_typeID]
            ]);
            //fetch registeredMemberUserIDs
            databaseInterfaceController.Queue('fetchEventRegistrationsByEvent_MemberID', [
                ['fetchEventRegistrationsByEvent_MemberID', 'true'],
                ['eventID', currentSelectedEvent.eventID],
                ['memberID', exAppContext.membership.memberID]
            ]);
        }

        //reset detailsImgErr
        SetDetailsImgErr(false);
    }, [currentSelectedEvent]);

    //watch for page update headerTitle
    useEffect(() => {
        if (prevPageRef.current != page) {
            switch (page) {
                case Events_PageMap.UPCOMING:
                case Events_PageMap.PAST:
                    //reset selectedEvent
                    if (prevPageRef.current != -1) {
                        SetCurrentSelectedEvent({} as Event);
                    }
                    if (page == Events_PageMap.UPCOMING) {
                        databaseInterfaceController.Queue('fetchUpcomingEvents', [
                            ['fetchUpcomingEvents', 'true'],
                            ['dateNow', IonDateString(new Date())]
                        ]);
                    } else {
                        pastEventsBatchFetchCountRef.current = 0;
                        databaseInterfaceController.Queue('fetchPastEventsByBatch', [
                            ['fetchPastEventsByBatch', 'true'],
                            ['dateNow', IonDateString(new Date())],
                            ['offset', pastEventsBatchFetchCountRef.current * nonstate.eventFetchBatchSize],
                            ['limit', nonstate.eventFetchBatchSize]
                        ]);
                        ResetPastEventScrollHandler();
                    }
                    appContext.SetHeaderTitle('DISCOVER EVENTS');
                    appContext.SetHeaderBackAction(() => function () { history.push('/Home') });
                    break;
                case Events_PageMap.DETAILS:
                    ResetFormVariables();
                    appContext.SetHeaderTitle('EVENT DETAILS');
                    appContext.SetHeaderBackAction(() => function () {
                        pageRef.current = Events_PageMap.UPCOMING;
                        SetPage(pageRef.current);
                        SetCurrentSelectedEvent({} as Event);
                    });

                    //fetch total number of registrant
                    databaseInterfaceController.Queue('fetchEventRegistrationsByID', [
                        ['fetchEventRegistrationsByID', 'true'],
                        ['eventID', currentSelectedEvent.eventID]
                    ]);
                    break;
                case Events_PageMap.JOIN:
                    appContext.SetHeaderTitle('FILL IN DETAILS');
                    appContext.SetHeaderBackAction(() => function () {
                        pageRef.current = Events_PageMap.DETAILS;
                        SetPage(pageRef.current);
                    });
                    break;
                case Events_PageMap.PAYMENT:
                    appContext.SetHeaderTitle('PAYMENT');
                    appContext.SetHeaderBackAction(() => function () {
                        pageRef.current = Events_PageMap.JOIN;
                        SetPage(pageRef.current);
                    });
                    break;
            }
            prevPageRef.current = page;
        }
    }, [page]);

    //watch for secondary members update newMemberSelected
    // useEffect(() => {
    //     const _newMemberSelected = [] as boolean[];
    //     memberUsers.map((memberUser: MemberUser, i: number) => {
    //         _newMemberSelected.push(false);
    //     });
    //     SetNewMemberSelected([..._newMemberSelected]);
    // }, [memberUsers]); ---deprecated to use exAppContext.membershipUsers
    useEffect(() => {
        const _newMemberSelected = [] as boolean[];
        exAppContext.membershipUsers.map((memberUser: MemberUser, i: number) => {
            _newMemberSelected.push(false);

        });
        SetNewMemberSelected([..._newMemberSelected]);
    }, [exAppContext.membershipUsers]);

    //watch for newMembersSelected & newPublicParticipants, initialize dietaryOptions & identification Documents
    useEffect(() => {
        const _newMemberDietaryOptions = [] as number[];
        const _newPublicDietaryOptions = [] as number[];
        newMemberDocsRef.current = [] as IdentificationDocument[];
        newPublicDocsRef.current = [] as IdentificationDocument[];

        newMemberSelected.map((selected: boolean) => {
            if (selected) {
                _newMemberDietaryOptions.push(0);
                newMemberDocsRef.current.push(new IdentificationDocument('', '', '', ''));
            }
        });
        newPublicParticipants.map((publicParticipant: PublicUser) => {
            _newPublicDietaryOptions.push(0);
            newPublicDocsRef.current.push(new IdentificationDocument('', '', '', ''));
        });

        SetNewMemberDietaryOptions([..._newMemberDietaryOptions]);
        SetNewPublicDietaryOptions([..._newPublicDietaryOptions]);
        SetNewMemberDocs([...newMemberDocsRef.current]);
        SetNewPublicDocs([...newPublicDocsRef.current]);

    }, [newMemberSelected, newPublicParticipants]);

    //watch for registrationSelectedMembers update eventRate
    useEffect(() => {
        let _eventRate = 0;
        //check group discount rate
        // if (currentSelectedEventFee.group_discount_rate > 0 && currentSelectedEventFee.min_group_discount_pax > 0) {
        //     if ((GetMembersSelectedCount(newMemberSelected) + newPublicParticipants.length) >= currentSelectedEventFee.min_group_discount_pax) {
        //         _eventRate = currentSelectedEventFee.group_discount_rate;
        //         if (isPlatform('hybrid')) {
        //             const ShowPriceRateChangeToast = async () => {
        //                 await Toast.show({ text: 'Group discounted rate applied!', position: 'top' });
        //             }
        //             ShowPriceRateChangeToast();
        //         } else {
        //             appContext.SetPopupMessage('Group discounted rate applied!');
        //         }
        //     }
        // }
        // if (_eventRate == 0) {
        //     //check date falls between earlybird, 
        //     const dateNow = new Date();
        //     if (
        //         (currentSelectedEventFee.early_bird_rate > 0 && currentSelectedEvent.early_bird_start_date != null && currentSelectedEvent.early_bird_end_date != null)
        //         && (dateNow >= currentSelectedEvent.early_bird_start_date && dateNow <= currentSelectedEvent.early_bird_end_date)
        //     ) {
        //         _eventRate = currentSelectedEventFee.early_bird_rate;
        //     }
        //     //use normal rate
        //     else {
        //         _eventRate = currentSelectedEventFee.normal_rate;
        //     }
        // } --deprecated, use new implementation

        const dateNow = new Date();
        let shouldUseGroupDiscountRate = false;
        //check for group discount rate
        if (currentSelectedEventFee.group_discount_rate > 0 && currentSelectedEventFee.min_group_discount_pax > 0) {
            if ((GetMembersSelectedCount(newMemberSelected) + newPublicParticipants.length) >= currentSelectedEventFee.min_group_discount_pax) {
                shouldUseGroupDiscountRate = true;
                // if (isPlatform('hybrid')) {
                //     const ShowPriceRateChangeToast = async () => {
                //         await Toast.show({ text: 'Group discounted rate applied!', position: 'top' });
                //     }
                //     ShowPriceRateChangeToast();
                // } else {
                //     appContext.SetPopupMessage('Group discounted rate applied!');
                // } --- temporary disabled
            }
        }

        if (
            (currentSelectedEventFee.early_bird_rate > 0 && currentSelectedEvent.early_bird_start_date != null && currentSelectedEvent.early_bird_end_date != null)
            && (dateNow >= currentSelectedEvent.early_bird_start_date && dateNow <= currentSelectedEvent.early_bird_end_date)
        ) {
            if (shouldUseGroupDiscountRate)
                _eventRate = currentSelectedEventFee.early_bird_group_discount_rate;
            else
                _eventRate = currentSelectedEventFee.early_bird_rate;
        }
        //use normal rate
        else {
            if (shouldUseGroupDiscountRate)
                _eventRate = currentSelectedEventFee.group_discount_rate;
            else
                _eventRate = currentSelectedEventFee.normal_rate;
        }

        if (_eventRate != undefined && !isNaN(_eventRate))
            SetEventRate(_eventRate);
    }, [currentSelectedEventFee, newMemberSelected, newPublicParticipants]);

    //watch for document upload count, upload document to server
    useEffect(() => {
        if (uploadMemberNricCount >= 0) {
            databaseInterfaceController.Queue('uploadMemberNric', [
                ['uploadMemberNric', 'true'],
                ['event_registrationID', eventRegistrationIDRef.current],
                ['fileName', newMemberDocs[uploadMemberNricCount].ic_fileName],
                ['base64String', newMemberDocs[uploadMemberNricCount].ic_base64String, false]
            ]);
        }
    }, [uploadMemberNricCount]);
    useEffect(() => {
        if (uploadMemberPassportCount >= 0) {
            databaseInterfaceController.Queue('uploadMemberPassport', [
                ['uploadMemberPassport', 'true'],
                ['event_registrationID', eventRegistrationIDRef.current],
                ['fileName', newMemberDocs[uploadMemberPassportCount].passport_filaName],
                ['base64String', newMemberDocs[uploadMemberPassportCount].passport_base64String, false]
            ]);
        }
    }, [uploadMemberPassportCount]);
    useEffect(() => {
        if (uploadPublicNricCount >= 0) {
            databaseInterfaceController.Queue('uploadPublicNric', [
                ['uploadPublicNric', 'true'],
                ['event_registrationID', eventRegistrationIDRef.current],
                ['fileName', newPublicDocs[uploadPublicNricCount].ic_fileName],
                ['base64String', newPublicDocs[uploadPublicNricCount].ic_base64String, false]
            ]);
        }
    }, [uploadPublicNricCount]);
    useEffect(() => {
        if (uploadPublicPassportCount >= 0) {
            databaseInterfaceController.Queue('uploadPublicPassport', [
                ['uploadPublicPassport', 'true'],
                ['event_registrationID', eventRegistrationIDRef.current],
                ['fileName', newPublicDocs[uploadPublicPassportCount].passport_filaName],
                ['base64String', newPublicDocs[uploadPublicPassportCount].passport_base64String, false]
            ]);
        }
    }, [uploadPublicPassportCount]);

    //watch for database result action
    useEffect(() => {
        if (appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'createEventRegistrationOrder':
                        if (!JSON.stringify(res).includes('_false')) {
                            // check upload identification documents
                            if (
                                IsStudyTrip()
                            ) {
                                appContext.SetWaitScreenMessage('Uploading identification documents');
                                appContext.SetWaitScreenShouldShow(true);
                                eventRegistrationIDRef.current = res['registrationID'];
                                if (newMemberDocs.length > 0) {
                                    uploadMemberNricCountRef.current = newMemberDocs.length - 1;
                                    SetUploadMemberNricCount(uploadMemberNricCountRef.current);

                                    uploadMemberPassportCountRef.current = newMemberDocs.length - 1;
                                    SetUploadMemberPassportCount(uploadMemberPassportCountRef.current);
                                }
                                if (newPublicDocs.length > 0) {
                                    uploadPublicNricCountRef.current = newPublicDocs.length - 1;
                                    SetUploadPublicNricCount(uploadMemberNricCountRef.current);

                                    uploadPublicPassportCountRef.current = newPublicDocs.length - 1;
                                    SetUploadPublicPassportCount(uploadPublicPassportCountRef.current);
                                }
                            } else {
                                //registration completed
                                pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                SetPage(pageRef.current);
                            }

                            /**---PAYMENT SECTIOLN TEMP DISABLED */
                            // const paymentID = res['paymentID'];

                            //TEST-START (auto update payment success and create referral code)
                            // const registrationID = res['registrationID'];
                            // databaseInterfaceController.Queue('updatePaymentComplete', [
                            //     ['updatePaymentComplete', 'true'],
                            //     ['paymentID', paymentID],
                            //     ['registrationID', registrationID]
                            // ]);
                            //TEST-END

                            // if (eventRate > 0) {
                            //     databaseInterfaceController.Queue('fetchPaymentInvoice', [
                            //         ['fetchPaymentInvoice', 'true'],
                            //         ['paymentID', paymentID]
                            //     ]);
                            // } else {
                            //     const registrationID = res['registrationID'];
                            //     databaseInterfaceController.Queue('updatePaymentComplete', [
                            //         ['updatePaymentComplete', 'true'],
                            //         ['paymentID', paymentID],
                            //         ['registrationID', registrationID]
                            //     ]);
                            // }

                        } else {
                            console.log('createEventRegistrationOrderErr: ' + res);
                        }
                        break;
                    case 'uploadMemberNric':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadMemberNricCountRef.current -= 1;
                            SetUploadMemberNricCount(uploadMemberNricCountRef.current);

                            if (
                                uploadMemberNricCountRef.current <= 0
                                && uploadMemberPassportCountRef.current <= 0
                                && uploadPublicNricCountRef.current <= 0
                                && uploadPublicPassportCountRef.current <= 0
                            ) {
                                appContext.SetWaitScreenShouldShow(false);
                                //registration completed
                                pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                SetPage(pageRef.current);
                            }
                        } else {
                            console.log('uploadMemberNricErr: ' + res);
                        }
                        break;
                    case 'uploadMemberPassport':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadMemberPassportCountRef.current -= 1;
                            SetUploadMemberPassportCount(uploadMemberPassportCountRef.current);

                            if (
                                uploadMemberNricCountRef.current <= 0
                                && uploadMemberPassportCountRef.current <= 0
                                && uploadPublicNricCountRef.current <= 0
                                && uploadPublicPassportCountRef.current <= 0
                            ) {
                                appContext.SetWaitScreenShouldShow(false);
                                //registration completed
                                pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                SetPage(pageRef.current);
                            }
                        } else {
                            console.log('uploadMemberPassportErr: ' + res);
                        }
                        break;
                    case 'uploadPublicNric':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadPublicNricCountRef.current -= 1;
                            SetUploadPublicNricCount(uploadPublicNricCountRef.current);

                            if (
                                uploadMemberNricCountRef.current <= 0
                                && uploadMemberPassportCountRef.current <= 0
                                && uploadPublicNricCountRef.current <= 0
                                && uploadPublicPassportCountRef.current <= 0
                            ) {
                                appContext.SetWaitScreenShouldShow(false);
                                //registration completed
                                pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                SetPage(pageRef.current);
                            }
                        } else {
                            console.log('uploadPublicNricErr: ' + res);
                        }
                        break;
                    case 'uploadPublicPassport':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadPublicPassportCountRef.current -= 1;
                            SetUploadPublicPassportCount(uploadPublicPassportCountRef.current);

                            if (
                                uploadMemberNricCountRef.current <= 0
                                && uploadMemberPassportCountRef.current <= 0
                                && uploadPublicNricCountRef.current <= 0
                                && uploadPublicPassportCountRef.current <= 0
                            ) {
                                appContext.SetWaitScreenShouldShow(false);
                                //registration completed
                                pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                SetPage(pageRef.current);
                            }
                        } else {
                            console.log('uploadMemberPassportErr: ' + res);
                        }
                        break;
                    case 'fetchPaymentInvoice':
                        if (!JSON.stringify(res).includes('_false')) {
                            //preps
                            let html_content = res.replace(/\{DeviceWidth\}/g, window.innerWidth);
                            html_content = html_content.replace(/\{ScaledHeight\}/g, window.innerWidth * /*1.414*/ 1.2);
                            html_content = html_content.replace(/\{ScaledFontSize\}/g, window.innerWidth * .015);
                            html_content = html_content.replace(/\{ScaledFontSize2\}/g, window.innerWidth * .016);
                            const elem = document.createElement('div');
                            elem.innerHTML = html_content;

                            //show wait screen
                            appContext.SetWaitScreenMessage('Generating invoice please wait');
                            appContext.SetWaitScreenShouldShow(true);

                            //start generate invoice pdf
                            document.body.appendChild(elem);

                            const doc = new jsPDF({
                                orientation: 'portrait',
                                unit: 'mm',
                                format: 'a4'
                            });
                            doc.addFileToVFS("OpenSans-Variable.ttf", OpenSansBase64);
                            doc.addFont("OpenSans-Variable.ttf", "Open Sans", "normal");
                            doc.addFont("OpenSans-Variable.ttf", "Open Sans Bold", "bold");
                            doc.setFont("Open Sans");
                            doc.html(elem, {
                                callback: async (doc: any) => {
                                    //delete last page (usually blanks)
                                    const pageCount = doc.internal.getNumberOfPages();
                                    if (pageCount > 1)
                                        doc.deletePage(pageCount);

                                    //out put pdf
                                    document.body.removeChild(elem);
                                    const blob = doc.output('blob');
                                    const url = URL.createObjectURL(blob);
                                    appContext.SetAppStateChangeWatch(false);
                                    if (isPlatform('hybrid')) {
                                        await SaveBlobToCache(blob).then(async (res: any) => {
                                            console.log('checkRes: ' + JSON.stringify(res));
                                        });
                                        appContext.SetAppStateChangeWatch(true);
                                        appContext.SetWaitScreenShouldShow(false);
                                        pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                    } else {
                                        appContext.SetAppStateChangeWatch(true);
                                        appContext.SetWaitScreenShouldShow(false);
                                        pageRef.current = Events_PageMap.INVOICE_COMPLETE
                                    }
                                    SetPage(pageRef.current);
                                },
                                x: 0, y: 0,
                                width: 210,
                                windowWidth: window.innerWidth
                            });
                        } else {
                            console.log('fetchPaymentInvoiceErr: ' + res);
                        }
                        break;
                    case 'updatePaymentComplete':
                        if (!JSON.stringify(res).includes('_false')) {
                            const registrationID = res;
                            databaseInterfaceController.Queue('generateEventRegistrationReferrals', [
                                ['generateEventRegistrationReferrals', 'true'],
                                ['eventRegistrationID', registrationID]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Payment unsuccessful!\nPlease try again.');
                            appContext.SetPopupButtons(['ok']);
                            appContext.SetPopupActions([() => {
                                pageRef.current = Events_PageMap.UPCOMING;
                                SetPage(pageRef.current);
                            }]);
                        }
                        break;
                    case 'generateEventRegistrationReferrals':
                        if (!JSON.stringify(res).includes('_false')) {
                            //refetch userEvents & userEventRegistrations
                            databaseInterfaceController.Queue('fetchUserUpcomingEvents', [
                                ['fetchUserUpcomingEvents', 'true'],
                                ['userID', appContext.user.userID],
                                ['dateNow', IonDateString(new Date())]
                            ]);
                            databaseInterfaceController.Queue('fetchUserEventRegistrations', [
                                ['fetchUserEventRegistrations', 'true'],
                                ['userID', appContext.user.userID]
                            ]);
                            pageRef.current = Events_PageMap.INVOICE_COMPLETE
                            SetPage(pageRef.current);
                        } else {
                            console.log('generateEventRegistrationReferralsErr: ' + res);
                        }
                        break;
                    case 'fetchUpcomingEvents':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            if (jsonObjs.length > 0) {
                                const _upcomingEvents = [] as Event[];
                                jsonObjs.map((obj: any) => {
                                    _upcomingEvents.push(new Event(
                                        obj['eventID'],
                                        obj['event_categoryID'],
                                        obj['event_name'],
                                        obj['event_name_highlight_texts'],
                                        obj['event_name_highlight_colors'],
                                        obj['event_desc'],
                                        obj['event_poster'],
                                        obj['event_file'],
                                        obj['event_venue'],
                                        obj['registration_start_date'],
                                        obj['registration_end_date'],
                                        obj['early_bird_start_date'],
                                        obj['early_bird_end_date'],
                                        obj['event_start_date'],
                                        obj['event_end_date'],
                                        obj['event_schedules'],
                                        obj['max_pax'],
                                        obj['hostID'],
                                        obj['datetime_created'],
                                        obj['datetime_updated'],
                                        obj['inapp_registration'],
                                        obj['external_registration_link']
                                        // obj['attachment_base_url'],
                                        // obj['attachment_file_names'] ---deprecated
                                    ))
                                });
                                SetUpcomingEvents([..._upcomingEvents]);
                            } /*else {
                                //no more upcoming events to fetch
                                eventFetchCountsIsMaxRef.current = { upcoming: true, past: eventFetchCountsIsMaxRef.current.past };
                            } ---deprecated, for upcomingEvents dont use batch fetching*/
                        } else {
                            console.log('fetchUpcomingEventsErr: ' + res);
                        }
                        break;
                    case 'fetchPastEventsByBatch':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }

                            if (jsonObjs.length > 0) {
                                const _pastEvents = pastEvents;
                                jsonObjs.map((obj: any) => {
                                    _pastEvents.push(new Event(
                                        obj['eventID'],
                                        obj['event_categoryID'],
                                        obj['event_name'],
                                        obj['event_name_highlight_texts'],
                                        obj['event_name_highlight_colors'],
                                        obj['event_desc'],
                                        obj['event_poster'],
                                        obj['event_file'],
                                        obj['event_venue'],
                                        obj['registration_start_date'],
                                        obj['registration_end_date'],
                                        obj['early_bird_start_date'],
                                        obj['early_bird_end_date'],
                                        obj['event_start_date'],
                                        obj['event_end_date'],
                                        obj['event_scheudles'],
                                        obj['max_pax'],
                                        obj['hostID'],
                                        obj['datetime_created'],
                                        obj['datetime_updated'],
                                        obj['inapp_registration'],
                                        obj['external_registration_link']
                                        // obj['attachment_base_url'],
                                        // obj['attachment_file_names'] ---deprecated
                                    ))
                                });
                                SetPastEvents([..._pastEvents]);

                                //block onscroll batchfetching when all past events fetched
                                if (jsonObjs.length < nonstate.eventFetchBatchSize) {
                                    eventScrollCheckRef.current = false;
                                    //this check should be reset when page renavigated, or refreshed
                                } else {
                                    eventScrollCheckRef.current = true;
                                    //continue allow user to fetch
                                }
                            }
                        } else {
                            console.log('fetchPastEventsByBatchErr: ' + res);
                        }
                        break;
                    case 'fetchEventFee_eventID_memberTypeID':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObj = {} as any;
                            try {
                                jsonObj = JSON.parse(res) as any;
                            } catch {
                                jsonObj = res as any;
                            }
                            if (jsonObj) {
                                SetCurrentSelectedEventFee(new EventFee(
                                    jsonObj['event_feeID'],
                                    jsonObj['eventID'],
                                    jsonObj['member_typeID'],
                                    jsonObj['early_bird_rate'],
                                    jsonObj['normal_rate'],
                                    jsonObj['group_discount_rate'],
                                    jsonObj['early_bird_group_discount_rate'],
                                    jsonObj['min_group_discount_pax'],
                                    jsonObj['creatorID'],
                                    jsonObj['updaterID'],
                                    jsonObj['datetime_created'],
                                    jsonObj['datetime_updated']
                                ));
                            }
                        } else {
                            console.log('fetchEventErr: ' + res);
                        }
                        break;
                    case 'fetchEventRegistrationsByID':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            let totalParticipants = 0;
                            resObjs.map((obj: any) => {
                                const eventRegistration = new EventRegistration(
                                    obj['event_registrationID'],
                                    obj['eventID'],
                                    obj['paymentID'],
                                    obj['initiatorID'],
                                    obj['beneficiaryIDs'],
                                    obj['doc_base_url'],
                                    obj['beneficiary_doc_ics'],
                                    obj['beneficiary_doc_passports'],
                                    obj['dietary_options'],
                                    obj['public_beneficiary_ids'],
                                    obj['public_beneficiary_salutations'],
                                    obj['public_beneficiary_fullnames'],
                                    obj['public_beneficiary_emails'],
                                    obj['public_beneficiary_phones'],
                                    obj['public_beneficiary_designations'],
                                    obj['public_beneficiary_doc_ics'],
                                    obj['public_beneficiary_doc_passports'],
                                    obj['public_beneficiary_rpm_nos'],
                                    obj['public_dietary_options'],
                                    obj['hrd_claim_status'],
                                    obj['hrd_grant_status'],
                                    obj['datetime_created'],
                                    obj['event_regRefIDs']
                                );
                                totalParticipants += eventRegistration.beneficiaryIDs.length;
                                totalParticipants += eventRegistration.public_beneficiary_ids.length;
                            });
                            SetEventTotalParticipants(totalParticipants);
                        } else {
                            console.log('fetchEventRegistrationsByIDErr: ' + res);
                        }
                        break;
                    case 'fetchEventRegistrationsByEvent_MemberID':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const registrations = [] as EventRegistration[];
                            resObjs.map((resObj: any) => {
                                registrations.push(new EventRegistration(
                                    resObj['event_registrationID'],
                                    resObj['eventID'],
                                    resObj['paymentID'],
                                    resObj['initiatorID'],
                                    resObj['beneficiaryIDs'],
                                    resObj['doc_base_url'],
                                    resObj['beneficiary_doc_ics'],
                                    resObj['beneficiary_doc_passports'],
                                    resObj['dietary_options'],
                                    resObj['public_beneficiary_ids'],
                                    resObj['public_beneficiary_salutations'],
                                    resObj['public_beneficiary_fullnames'],
                                    resObj['public_beneficiary_emails'],
                                    resObj['public_beneficiary_phones'],
                                    resObj['public_beneficiary_designations'],
                                    resObj['public_beneficiary_doc_ics'],
                                    resObj['public_beneficiary_doc_passports'],
                                    resObj['public_beneficiary_rpm_nos'],
                                    resObj['public_dietary_options'],
                                    resObj['hrd_claim_status'],
                                    resObj['hrd_grant_status'],
                                    resObj['datetime_created'],
                                    resObj['event_regRefIDs']
                                ));
                            });
                            SetSelectedEventRegistrations([...registrations]);
                        }
                        break;
                    case 'fetchEventByID':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObj = {} as any;
                            try {
                                resObj = JSON.parse(res) as any;
                            } catch {
                                resObj = res as any;
                            }
                            SetCurrentSelectedEvent(new Event(
                                resObj['eventID'],
                                resObj['event_categoryID'],
                                resObj['event_name'],
                                resObj['event_name_highlight_texts'],
                                resObj['event_name_highlight_colors'],
                                resObj['event_desc'],
                                resObj['event_poster'],
                                resObj['event_file'],
                                resObj['event_venue'],
                                resObj['registration_start_date'],
                                resObj['registration_end_date'],
                                resObj['early_bird_start_date'],
                                resObj['early_bird_end_date'],
                                resObj['event_start_date'],
                                resObj['event_end_date'],
                                resObj['event_schedules'],
                                resObj['max_pax'],
                                resObj['hostID'],
                                resObj['datetime_created'],
                                resObj['datetime_updated'],
                                resObj['inapp_registration'],
                                resObj['external_registration_link'],
                                resObj['first_gallery_img'],
                            ));
                        } else {
                            console.log('fetchEventByIDErr: ' + res);
                        }
                        break;
                }
            }
            switch (appContext.databaseActionModeQueue[0]) {
                case 'createEventRegistrationOrder':
                case 'uploadMemberNric':
                case 'uploadMemberPassport':
                case 'uploadPublicNric':
                case 'uploadPublicPassport':
                case 'fetchPaymentInvoice':
                case 'updatePaymentComplete':
                case 'generateEventRegistrationReferrals':
                case 'fetchEventFee_eventID_memberTypeID':
                case 'fetchUpcomingEvents':
                case 'fetchPastEventsByBatch':
                case 'fetchEventRegistrationsByID':
                case 'fetchEventRegistrationsByEvent_MemberID':
                case 'fetchEventByID':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnSearchBtnClicked = () => {
        SetFilter_searchString(preSearchString);
    }

    const OnSelectUnSelectMember = (i: number) => {
        const _newMemberSelected = newMemberSelected;
        if (
            currentSelectedEvent.max_pax == 0
            ||
            (_newMemberSelected[i] == false && GetTotalAttemptedParticipants() < currentSelectedEvent.max_pax - eventTotalParticipants)
            ||
            _newMemberSelected[i] == true
        ) {
            _newMemberSelected[i] = !(_newMemberSelected[i]);
            SetNewMemberSelected([..._newMemberSelected]);
        } else {
            appContext.SetPopupMessage("You've reached maximum number of participants to be register for this event");
        }
    }
    const OnPayBtnClicked = () => {
        // databaseInterfaceController.Queue('createEventRegistration', [
        //     ['createEventRegistration', 'true'],
        //     ['eventID', currentSelectedEvent.eventID],
        //     ['initiatorID', appContext.user.userID],
        //     ['beneficiaryIDs', GeneratePublicBeneficiaryIDs()],
        //     ['contactName', newContactName],
        //     ['contactEmail', newContactEmail],
        //     ['contactPhone', newCountryCode + newContactPhone],
        //     ['amount', CalculatePriceTotal()]
        // ]);
    }
    // const OnGenerateInvoiceClicked = () => {
    //     if (
    //         newBillingName.length >= 3
    //         && newBillingAddress.length >= 3
    //         && newEInvoicePin.length >= 3
    //         && newContactName.length >= 3
    //         && newContactEmail.length >= 3
    //         && newContactPhone.length >= 3
    //     ) {
    //         if (
    //             (GetNumberOfMemberSelected(newMemberSelected) > 0 || newPublicParticipants.length > 0)
    //         ) {
    //             //get total selected members
    //             let membersSelectedCount = 0;
    //             newMemberSelected.map((isSelected: boolean) => {
    //                 if (isSelected)
    //                     membersSelectedCount += 1;
    //             });

    //             databaseInterfaceController.Queue('createEventRegistrationOrder', [
    //                 ['createEventRegistrationOrder', 'true'],
    //                 ['eventID', currentSelectedEvent.eventID],
    //                 ['initiatorID', appContext.user.userID],
    //                 ['beneficiaryIDs', GenerateBeneficiaryIDs()],
    //                 ['public_beneficiary_ids', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.ID)],
    //                 ['public_beneficiary_fullnames', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.FULL_NAME)],
    //                 ['public_beneficiary_emails', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.EMAIL)],
    //                 ['public_beneficiary_phones', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.PHONE)],
    //                 ['contactName', newContactName],
    //                 ['contactPhone', newCountryCode + newContactPhone],
    //                 ['contactEmail', newContactEmail],
    //                 ['billing_name', newBillingName],
    //                 ['billing_address', newBillingAddress],
    //                 ['e_invoice_pin', newEInvoicePin],
    //                 ['itemIDs', currentSelectedEventFee.event_feeID],
    //                 ['pax', membersSelectedCount + newPublicParticipants.length],
    //                 ['amounts', eventRate]
    //             ]);

    //         } else {
    //             appContext.SetPopupMessage('You are required to enter at least 1 participant to join the event.');
    //         }
    //     } else {
    //         appContext.SetPopupMessage(GetFormFillRequiredMessage());
    //     }
    // }
    const OnRegistrationProceedClicked = () => {
        if (
            newBillingName.length >= 3
            && newBillingAddress.length >= 3
            /*&& newEInvoicePin.length >= 3 ---deprecated*/
            && newContactName.length >= 3
            && newContactEmail.length >= 3
            && newContactPhone.length >= 3
            && newContactOfficeNo.length >= 3
        ) {
            if (
                (GetNumberOfMemberSelected(newMemberSelected) > 0 || newPublicParticipants.length > 0)
            ) {
                //check is study trip or not
                if (IsStudyTrip()) {
                    SetShouldShowUploadIdentificationDocumentsMenu(true);
                } else {
                    SetShouldShowDietaryMenu(true);
                }
            } else {
                appContext.SetPopupMessage('You are required to enter at least 1 participant to join the event.');
            }
        } else {
            appContext.SetPopupMessage(GetFormFillRequiredMessage());
        }
    }
    const OnSubmitRegistrationClicked = () => {
        if (
            newBillingName.length >= 3
            && newBillingAddress.length >= 3
            /*&& newEInvoicePin.length >= 3 ---deprecated*/
            && newContactName.length >= 3
            && newContactEmail.length >= 3
            && newContactPhone.length >= 3
            && newContactOfficeNo.length >= 3
        ) {
            if (
                (GetNumberOfMemberSelected(newMemberSelected) > 0 || newPublicParticipants.length > 0)
            ) {
                //get total selected members
                let membersSelectedCount = 0;
                newMemberSelected.map((isSelected: boolean) => {
                    if (isSelected)
                        membersSelectedCount += 1;
                });

                if (currentSelectedEventFee) {
                    databaseInterfaceController.Queue('createEventRegistrationOrder', [
                        ['createEventRegistrationOrder', 'true'],
                        ['eventID', currentSelectedEvent.eventID],
                        ['initiatorID', appContext.user.userID],
                        ['beneficiaryIDs', GenerateBeneficiaryIDs()],
                        ['dietary_options', newMemberDietaryOptions.join(',')],
                        ['public_beneficiary_ids', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.ID)],
                        ['public_beneficiary_salutations', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.SALUTATION)],
                        ['public_beneficiary_fullnames', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.FULL_NAME)],
                        ['public_beneficiary_emails', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.EMAIL)],
                        ['public_beneficiary_phones', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.PHONE)],
                        ['public_beneficiary_designations', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.DESIGNATION)],
                        ['public_beneficiary_rpm_nos', GeneratePublicBeneficiaryDetails(Events_PublicBeneficiaryMode.RPM_NO)],
                        ['public_dietary_options', newPublicDietaryOptions.join(',')],
                        ['contact_salutation', newContactSalutation],
                        ['contact_other_salutation', newContactOtherSalutation],
                        ['contactName', newContactName],
                        ['contactPhone', newCountryCode + newContactPhone],
                        ['contactOfficeNo', newContactOfficeNo],
                        ['contactEmail', newContactEmail],
                        ['billing_name', newBillingName],
                        ['billing_address', newBillingAddress],
                        ['e_invoice_pin', newEInvoicePin],
                        ['hrd_claim_status', newHRDClaimStatus],
                        ['itemIDs', currentSelectedEventFee.event_feeID],
                        ['pax', membersSelectedCount + newPublicParticipants.length],
                        ['amounts', eventRate]
                    ]);
                }

            } else {
                appContext.SetPopupMessage('You are required to enter at least 1 participant to join the event.');
            }
        } else {
            appContext.SetPopupMessage(GetFormFillRequiredMessage());
        }
    }
    const OnJoinNowBtnClicked = async() => {
        if (
            currentSelectedEvent.max_pax == 0
            || currentSelectedEvent.max_pax - eventTotalParticipants > 0
        ) {
            if (
                IsRegistrationOpen(currentSelectedEvent)
            ) {
                if(currentSelectedEvent.external_registration_link == '') {
                    pageRef.current = Events_PageMap.JOIN;
                    SetPage(pageRef.current);
                } else {
                    await Browser.open({ url: currentSelectedEvent.external_registration_link });
                }
            } else {
                appContext.SetPopupMessage('Online registration is closed for this event.');
            }
        }
        else {
            appContext.SetPopupMessage('This event has reached full capacity, no more avilable slots left.');
        }
    }
    const OnRemovePublicUserClicked = (index: number) => {
        appContext.SetPopupMessage('Are you sure to remove this participant ?');
        appContext.SetPopupButtons(['Yea', 'No']);
        appContext.SetPopupActions([() => {
            const _newPublicParticipants = newPublicParticipants;
            _newPublicParticipants.splice(index, 1);
            SetNewPublicParticipants([..._newPublicParticipants]);
        }, () => { }]);
    }
    const OnAddPublicParticipantClicked = () => {
        if (
            newPublicUserFullName.length >= 3 &&
            newPublicUserIC.length == 12 &&
            newPublicUserEmail.length >= 3 &&
            newPublicUserPhone.length >= 10
            && newPublicUserDesignation.length >= 0
        ) {
            const _newPublicParticipants = newPublicParticipants;
            _newPublicParticipants.push(new PublicUser(
                newPublicUserIC, newPublicUserSalutation.toString(), newPublicUserFullName, newPublicUserEmail, newPublicUserPhone, newPublicUserDesignation, newPublicUserRPMNo
            ));
            SetNewPublicParticipants([..._newPublicParticipants]);
            SetShouldShowAddPublicParticipantMenu(false);
            ResetAddPublicParticipantFormVariables();
        } else {
            appContext.SetPopupMessage("You must fill out all fields marked (*)");
        }
    }
    const OnAttemptAddPublicParticipants = () => {
        if (
            currentSelectedEvent.max_pax == 0
            || GetTotalAttemptedParticipants() < currentSelectedEvent.max_pax - eventTotalParticipants
        )
            SetShouldShowAddPublicParticipantMenu(true);
        else {
            appContext.SetPopupMessage("You've reached maximum number of participants to be register for this event");
        }
    }
    const OnAddPublicParticipantNRIC = (nric: string) => {
        //no checking needed for empty
        if (nric != '') {
            //check nric available
            if (nric.length >= 14) {
                let isFound = false;
                let isMemberUser = false;
                const _nric = nric.replace(/[-]/g, '');
                //nric cannot be the same as any memberUsers
                exAppContext.membershipUsers.map((memberUser: MemberUser) => {
                    if (memberUser.nric == _nric)
                        isMemberUser = true;
                });

                if (!isMemberUser) {
                    //loop through registrations
                    selectedEventRegistrations.map((registration: EventRegistration) => {
                        //check registered in public participants
                        if (registration.public_beneficiary_ids.join(',').includes(_nric)) {
                            isFound = true;
                        }
                    });
                    if (isFound) {
                        appContext.SetPopupMessage('This NRIC No. has already being registered for this event.');
                        SetNewPublicUserIC('');
                    }
                } else {
                    appContext.SetPopupMessage('This NRIC No. belongs to one of the reigstered membership accounts.');
                    SetNewPublicUserIC('');
                }
            } else {
                appContext.SetPopupMessage('Please provide a valid NRIC No.');
                SetNewPublicUserIC('');
            }
        }
    }
    const OnAddPublicParticipantEmail = (email: string) => {
        if (email != '') {
            //check nric available
            if (
                email.length > 3
                && email.includes('@')
                && email.includes('.')
            ) {
                let isFound = false;
                let isMemberUser = false;

                //nric cannot be the same as any memberUsers
                exAppContext.membershipUsers.map((memberUser: MemberUser) => {
                    if (memberUser.email == email)
                        isMemberUser = true;
                });

                if (!isMemberUser) {
                    //loop through registrations
                    selectedEventRegistrations.map((registration: EventRegistration) => {
                        //check registered in public participants
                        if (registration.public_beneficiary_emails.join(',').includes(email)) {
                            isFound = true;
                        }
                    });
                    if (isFound) {
                        appContext.SetPopupMessage('This email address has already being registered for this event.');
                        SetNewPublicUserEmail('');
                    }
                } else {
                    appContext.SetPopupMessage('This email address belongs to one of the reigstered membership accounts.');
                    SetNewPublicUserEmail('');
                }
            } else {
                appContext.SetPopupMessage('Please provide a valid email address.');
                SetNewPublicUserEmail('');
            }
        }
    }
    const OnAddPublicParticipantPhone = (phone: string) => {
        if (phone.length > 4) {
            //check nric available
            if (phone.length >= 13) {
                let isFound = false;
                let isMemberUser = false;
                const _phone = phone.replace(/[+\s]/g, '');

                //nric cannot be the same as any memberUsers
                exAppContext.membershipUsers.map((memberUser: MemberUser) => {
                    if (memberUser.handphone_code + memberUser.handphone_no == _phone)
                        isMemberUser = true;
                });

                if (!isMemberUser) {
                    //loop through registrations
                    selectedEventRegistrations.map((registration: EventRegistration) => {
                        //check registered in public participants
                        if (registration.public_beneficiary_phones.join(',').includes(_phone)) {
                            isFound = true;
                        }
                    });
                    if (isFound) {
                        appContext.SetPopupMessage('This Mobile No. has already being registered for this event.');
                        SetNewPublicUserPhone('');
                    }
                } else {
                    appContext.SetPopupMessage('This Mobile No. belongs to one of the reigstered membership accounts.');
                    SetNewPublicUserPhone('');
                }
            } else {
                appContext.SetPopupMessage('Please provide a valid Mobile No.');
                SetNewPublicUserPhone('');
            }
        }
    }
    const OnUploadDocumentClicked = (userType: string, documentType: string, index: number) => {
        Camera.getPhoto({
            resultType: CameraResultType.Uri
        }).then((res) => {
            ResizeImage(
                (res.webPath ? res.webPath : ''),
                userType,
                documentType,
                index
            );
            appContext.SetAppStateChangeWatch(true);
        }).catch((err) => {
            console.log('checkErr: ' + err);
            appContext.SetAppStateChangeWatch(true);
        });
    }
    const OnRemoveDocumentClicked = (userType: string, documentType: string, index: number) => {
        switch (userType) {
            case 'member':
                if (documentType == 'nric') {
                    newMemberDocsRef.current[index] = new IdentificationDocument(
                        '',
                        '',
                        newMemberDocsRef.current[index].passport_filaName,
                        newMemberDocsRef.current[index].passport_base64String
                    );
                } else if (documentType == 'passport') {
                    newMemberDocsRef.current[index] = new IdentificationDocument(
                        newMemberDocsRef.current[index].ic_fileName,
                        newMemberDocsRef.current[index].ic_base64String,
                        '',
                        ''
                    );
                }
                SetNewMemberDocs([...newMemberDocsRef.current]);
                break;
            case 'public':
                if (documentType == 'nric') {
                    newPublicDocsRef.current[index] = new IdentificationDocument(
                        '',
                        '',
                        newPublicDocsRef.current[index].passport_filaName,
                        newPublicDocsRef.current[index].passport_base64String
                    );
                } else if (documentType == 'passport') {
                    newPublicDocsRef.current[index] = new IdentificationDocument(
                        newPublicDocsRef.current[index].ic_fileName,
                        newPublicDocsRef.current[index].ic_base64String,
                        '',
                        ''
                    );
                }
                SetNewPublicDocs([...newPublicDocsRef.current]);
                break;
        }
    }

    //render functions
    const RenderPages = () => {
        switch (page) {
            default:
            case Events_PageMap.UPCOMING:
                return RenderUpcomingEvents();
            case Events_PageMap.PAST:
                return RenderPastEvents();
            case Events_PageMap.DETAILS:
                return RenderEventDetails();
            case Events_PageMap.JOIN:
                return RenderEventJoinForm();
            case Events_PageMap.PAYMENT:
                return RenderEventPayment();
            case Events_PageMap.INVOICE_COMPLETE:
                return RenderInvoiceComplete();
        }
    }
    const RenderTopOptions = () => {
        switch (page) {
            case Events_PageMap.UPCOMING:
            case Events_PageMap.PAST:
                return (
                    <Fragment>
                        <div className='option-panel-row'>
                            <div className='search-bar'>
                                <input className='search-bar-in' onChange={(e: any) => { SetPreSearchString(e.target.value) }} value={preSearchString} onFocus={() => SetPreSearchString('')} placeholder='search' />
                                <button className='search-btn' onClick={() => OnSearchBtnClicked()}><SearchIcon /></button>
                            </div>
                            <button className='my-events-btn' onClick={() => history.push('/MyEvents')}>
                                <LocalActivityIcon />
                                My{appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? ' ' : <br />}Events
                            </button>
                        </div>
                        <div className='option-panel-row'>
                            <button className={'option-btn ' + (page == Events_PageMap.UPCOMING ? 'selected' : '')} onClick={() => { pageRef.current = Events_PageMap.UPCOMING; SetPage(pageRef.current); }}>Current</button>
                            <button className={'option-btn ' + (page == Events_PageMap.PAST ? 'selected' : '')} onClick={() => { pageRef.current = Events_PageMap.PAST; SetPage(pageRef.current); }}>Past</button>
                            <div className={'option-indicator ' + (GetKeyOfObjectByValue(Events_PageMap, page))} />
                        </div>
                    </Fragment>
                )
            default:
                return null;
        }
    }
    const RenderBottomOptions = () => {
        switch (page) {
            case Events_PageMap.UPCOMING:
            case Events_PageMap.PAST:
                return (
                    <Fragment>
                        <div className='filter-panel'>
                            <span className='filter-panel-title'>Filter By</span>
                            <SelectionBox selectionList={selectionList_eventCategory} selectingKey={filter_eventCategory} SetSelectingKey={SetFilter_eventCategory} direction='up' />
                        </div>
                        <div className='scroll-nav-panel'>
                            <button className='scroll-nav-btn' onClick={() => { eventScrollRef.current.scrollTo({ top: 0, behaviour: 'smooth' }); }}><ArrowDropUpIcon /></button>
                            <button className='scroll-nav-btn' onClick={() => { eventScrollRef.current.scrollTo({ top: eventScrollRef.current.scrollHeight, behaviour: 'smooth' }); }}><ArrowDropDownIcon /></button>
                        </div>
                    </Fragment>
                )
        }
    }
    const RenderUpcomingEvents = () => {
        const filteredEvents = FilterEventsBySearchString(
            FilterEventsByCategory(
                upcomingEvents
            )
        );

        return (
            <Fragment>
                <div className='events-scroll' ref={eventScrollRef}>
                    {
                        filteredEvents.length > 0 ?
                            filteredEvents.map((event: Event, i: number) => RenderEventCard(event, i))
                            :
                            <span className='events-scroll-lbl'>There're no current events found</span>
                    }
                </div>
            </Fragment>
        )
    }
    const RenderPastEvents = () => {
        const filteredEvents = FilterEventsBySearchString(
            FilterEventsByCategory(
                pastEvents
            )
        );

        return (
            <Fragment>
                <div className='events-scroll' ref={eventScrollRef}>
                    {
                        filteredEvents.length > 0 ?
                            filteredEvents.map((event: Event, i: number) => RenderEventCard(event, i))
                            :
                            <span className='events-scroll-lbl'>There're no past events found</span>
                    }
                </div>
            </Fragment>
        )
    }
    const RenderEventDetails = () => {
        if (Object.keys(currentSelectedEvent).length > 0) {
            return (
                <div className='details-card'>
                    {
                        !detailsImgErr ?
                            <ImagePreviewer className='details-card-img' src={currentSelectedEvent.event_poster} onError={() => SetDetailsImgErr(true)} />
                            :
                            <ImagePreviewer className='details-card-img' src={DefaultImage} />
                    }
                    <span className='details-card-title'>{currentSelectedEvent.event_name}</span>
                    <div className='details-card-row'>
                        <LocationOnIcon />
                        <span className='details-card-lbl'>{currentSelectedEvent.event_venue}</span>
                    </div>
                    <div className='details-card-row'>
                        <DateRangeIcon />
                        <span className='details-card-lbl'>From {IonDateString(currentSelectedEvent.event_start_date, IonDateFormat.LONG_DATE)} <br /> To {IonDateString(currentSelectedEvent.event_end_date, IonDateFormat.LONG_DATE)}</span>
                    </div>
                    {
                        currentSelectedEvent.event_schedules.length > 0 ?
                            <div className='details-card-row'>
                                <AccessTimeIcon />
                                <div className='details-card-table'>
                                    <div className='details-card-table-row'>
                                        <span className='details-card-table-title'>Date</span>
                                        <span className='details-card-table-title'>Start</span>
                                        <span className='details-card-table-title'>End</span>
                                    </div>
                                    {
                                        currentSelectedEvent.event_schedules.map((dailySchedule: any[], i: number) => {
                                            return (
                                                <div className='details-card-table-row' key={'details-card-table-row-' + i}>
                                                    <span className='details-card-table-lbl'>{IonDateString(dailySchedule[0], IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
                                                    <span className='details-card-table-lbl'>{IonDateString(dailySchedule[0], IonDateFormat.TIME_12)}</span>
                                                    <span className='details-card-table-lbl'>{IonDateString(dailySchedule[1], IonDateFormat.TIME_12)}</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        currentSelectedEvent.event_desc.replace(/\s/g, '').length > 0 ?
                            <Fragment>
                                <span className='details-card-title'>Descriptions</span>
                                <div className='details-card-row'>
                                    <span className='details-card-paragraph'>{currentSelectedEvent.event_desc}</span>
                                </div>
                            </Fragment>
                            :
                            null
                    }
                    <br />
                    {
                        currentSelectedEventFee.early_bird_rate > 0
                            || currentSelectedEventFee.normal_rate > 0
                            || currentSelectedEventFee.group_discount_rate > 0
                            || currentSelectedEventFee.early_bird_group_discount_rate > 0 ?
                            <Fragment>
                                <span className='details-card-title'>Registration Fee</span>
                                <div className='details-card-row'>
                                    <div className='details-card-table'>
                                        <div className='details-card-table-row'>
                                            <span className='details-card-table-title flex-2'>Condition</span>
                                            <span className='details-card-table-title'>Price/Pax</span>
                                        </div>
                                        {
                                            currentSelectedEventFee.early_bird_rate > 0 ?
                                                <div className='details-card-table-row'>
                                                    <span className='details-card-table-lbl flex-2 ex'>Register before {IonDateString(currentSelectedEvent.early_bird_end_date, IonDateFormat.MALAYSIA_STANDARD_DATE)}.</span>
                                                    <span className='details-card-table-lbl'>RM {currentSelectedEventFee.early_bird_rate.toFixed(2)}</span>
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            currentSelectedEventFee.early_bird_group_discount_rate > 0 ?
                                                <div className='details-card-table-row'>
                                                    <span className='details-card-table-lbl flex-2 ex'>More than {currentSelectedEventFee.min_group_discount_pax} persons registered under same registration.<br />Register before {IonDateString(currentSelectedEvent.early_bird_end_date, IonDateFormat.MALAYSIA_STANDARD_DATE)}.</span>
                                                    <span className='details-card-table-lbl'>RM {currentSelectedEventFee.early_bird_group_discount_rate.toFixed(2)}</span>
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            currentSelectedEventFee.normal_rate > 0 ?
                                                <div className='details-card-table-row'>
                                                    <span className='details-card-table-lbl flex-2 ex'>Normal rate</span>
                                                    <span className='details-card-table-lbl'>RM {currentSelectedEventFee.normal_rate.toFixed(2)}</span>
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            currentSelectedEventFee.group_discount_rate > 0 ?
                                                <div className='details-card-table-row'>
                                                    <span className='details-card-table-lbl flex-2 ex'>More than {currentSelectedEventFee.min_group_discount_pax} persons registered under same registration.</span>
                                                    <span className='details-card-table-lbl'>RM {currentSelectedEventFee.group_discount_rate.toFixed(2)}</span>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                            </Fragment>
                            :
                            null
                    }
                    {
                        currentSelectedEvent.event_file.length > 0 ?
                            <div className='details-card-row'>
                                <button className='more-details-btn' onClick={async () => { await Browser.open({ url: currentSelectedEvent.event_file }); }}>View More Details <FeedIcon /></button>
                            </div>
                            :
                            null
                    }
                    {/* <div className='details-card-row'>
                        <button className='details-card-attachment-btn'>View More Details <FeedIcon /></button>
                    </div> */}
                    {
                        IsRegistrationOpen(currentSelectedEvent)
                            && currentSelectedEvent.max_pax > 0 ?
                            <div className='details-card-row'>
                                <span className='details-card-lbl ex'>{currentSelectedEvent.max_pax - eventTotalParticipants > 0 ? currentSelectedEvent.max_pax - eventTotalParticipants : '0'} seats left</span>
                            </div>
                            :
                            null
                    }
                    {
                        IsRegistrationOpen(currentSelectedEvent) && (currentSelectedEvent.inapp_registration || currentSelectedEvent.external_registration_link != '') ?
                            <button className='details-card-join-btn' onClick={() => OnJoinNowBtnClicked()}>Join Now</button>
                            :
                            null
                    }
                    {
                        IsUpcomingEvent(currentSelectedEvent)
                            && !IsRegistrationOpen(currentSelectedEvent)
                            && !IsRegistrationOver(currentSelectedEvent) ?
                            <span className='details-card-subtitle'>Registration starts on {IonDateString(currentSelectedEvent.registration_start_date, IonDateFormat.LONG_DATE)}</span>
                            :
                            (
                                IsRegistrationOver(currentSelectedEvent) ?
                                    <span className='details-card-subtitle'>Registration ended at<br />{IonDateString(currentSelectedEvent.registration_end_date, IonDateFormat.LONG_DATE)}</span>
                                    :
                                    null
                            )
                    }
                </div >
            )
        } else {
            return null;
        }
    }
    const RenderEventJoinForm = () => {
        return (
            <div className='join-form'>
                {
                    currentSelectedEvent.max_pax > 0 ?
                        <div className='join-form-col'>
                            <span className='join-form-lbl ex'> {GetTotalAttemptedParticipants()} / {currentSelectedEvent.max_pax - eventTotalParticipants > 0 ? currentSelectedEvent.max_pax - eventTotalParticipants : '0'} seats left</span>
                        </div>
                        :
                        null
                }
                {/* Billing Info */}
                <span className='join-form-title'>Billing Info</span>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>{/*IsNotAssociateMember() --deprecated*/IsCorporate() ? 'Company Name' : 'Full Name (as per NRIC)'} *</span>
                    <input className='join-form-in' value={newBillingName} onChange={(e: any) => SetNewBillingName(e.target.value)} placeholder={/*IsNotAssociateMember() --deprecated */IsCorporate() ? 'e.g. Neudimenxion' : 'e.g. Olivia Wilson'} />
                </div>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Billing Address *</span>
                    <textarea className='join-form-area' value={newBillingAddress} onChange={(e: any) => SetNewBillingAddress(e.target.value)} placeholder='e.g. B-5-8 Plaza Mont Kiara, Mont Kiara, 50480 Kuala Lumpur' />
                </div>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>E-Invoice/TIN No.</span>
                    <input className='join-form-in' value={newEInvoicePin} onChange={(e: any) => SetNewEInvoicePin(e.target.value)} placeholder='e.g. INV1234567890PIN' />
                </div>
                <div className='join-form-break' />

                {/** Contact Person Info */}
                <span className='join-form-title'>Contact Person Info</span>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Salutation *</span>
                    {/* <div className='join-form-select'>
                        <SelectionBox selectionList={nonstate.salutationSelectionList} selectingKey={newContactSalutation.toString()} SetSelectingKey={SetNewContactSalutation} />
                    </div> */}
                    <input className='join-form-in' value={newContactSalutation} onChange={(e: any) => SetNewContactSalutation(e.target.value.replace(/[^a-zA-Z ]/g, ''))} placeholder="contact person's salutation"/>
                </div>
                {/*
                    newContactSalutation == 12 ?
                        <div className='join-form-col'>
                            <span className='join-form-lbl'>Preferred Salutation *</span>
                            <input className='join-form-in' value={newContactOtherSalutation} onChange={(e: any) => SetNewContactOtherSalutation(e.target.value)} placeholder='other salutation' />
                        </div>
                        :
                        null
                */}
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Name *</span>
                    <input className='join-form-in' value={newContactName} onChange={(e: any) => SetNewContactName(e.target.value)} placeholder='e.g. Olivia Wilson' />
                </div>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Email *</span>
                    <input className='join-form-in' value={newContactEmail} onChange={(e: any) => SetNewContactEmail(e.target.value)} placeholder='exmaple@gmail.com' />
                </div>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Mobile No. *</span>
                    <div className='join-form-row'>
                        <div className='join-form-select ex'>
                            <SelectionBox
                                selectingKey={newCountryCode} SetSelectingKey={SetNewCountryCode} selectionList={selectionList_countryCode}
                                displayKey={false}
                            />
                        </div>
                        <input className='join-form-in' value={newContactPhone} onChange={(e: any) => SetNewContactPhone(FormatPhoneNumber(e.target.value, newCountryCode))} placeholder='10XXXXXXX' />
                    </div>
                </div>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Office No. *</span>
                    <div className='join-form-col'>
                        <input className='join-form-in' value={newContactOfficeNo} onChange={(e: any) => SetNewContactOfficeNo(e.target.value)} placeholder='+60 X-YYYY YYYY' />
                    </div>
                </div>
                {
                    !IsTTTEvent() ?
                    <div className='join-form-col'>
                    <span className='join-form-lbl'>Are you applying for HRD Corp Grant?</span>
                    <div className='join-form-toggle'>
                        <ToggleSlider
                            labelA='No'
                            labelB='Yes'
                            toggled={newHRDClaimStatus == EventRegistration_HRDClaimStatusMap.HRD_CLAIM ? true : false}
                            SetToggled={(res: boolean) => {
                                if (res)
                                    SetNewHRDClaimStatus(EventRegistration_HRDClaimStatusMap.HRD_CLAIM);
                                else
                                    SetNewHRDClaimStatus(EventRegistration_HRDClaimStatusMap.NO_HRD_CLAIM);
                            }}
                        />
                    </div>
                </div>
                    :
                    null
                }
                <div className='join-form-break' />
                {/** Participants Info */}
                <span className='join-form-title'>Participants Info</span>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Assign Accounts to Join</span>
                    {
                        // memberUsers.map((member: MemberUser, i: number) => RenderFormMemberBlock(member, i)) ---deprecated to use exAppContext.membershipUsers
                        exAppContext.membershipUsers.map((member: MemberUser, i: number) => RenderFormMemberBlock(member, i))
                    }
                </div>
                <div className='join-form-col'>
                    <span className='join-form-lbl'>Other Participants</span>
                    <div className='join-form-scroll'>
                        {
                            newPublicParticipants.map((publicUser: PublicUser, i: number) => RenderFormPublicParticipantBlock(publicUser, i))
                        }
                        {
                            selectedEventRegistrations.map((registration: EventRegistration, i: number) => {
                                return registration.public_beneficiary_ids.map((id: string, u: number) => RenderFormPublicParticipantBlock(new PublicUser(
                                    id,
                                    registration.public_beneficiary_salutations[u],
                                    registration.public_beneficiary_fullnames[u],
                                    registration.public_beneficiary_emails[u],
                                    registration.public_beneficiary_phones[u],
                                    registration.public_beneficiary_designations[u],
                                    registration.public_beneficiary_rpm_nos[u]
                                ), i, true))
                            })
                        }
                    </div>
                    <button className='join-form-btn ex' onClick={() => OnAttemptAddPublicParticipants()}>Add Other Participant</button>
                </div>
                <div className='join-form-break' />

                {/**Payment Info */}
                {/*<span className='join-form-title'>Payment Info</span>
                <div className='join-form-payment-col'>
                    <span className='join-form-payment-lbl'>Payment Details</span>
                    <div className='join-form-payment-row'>
                        <span className='join-form-payment-row-lbl ex'>Subtotal</span>
                        <span className='join-form-payment-row-lbl ex'>RM {eventRate.toFixed(2) + (eventRate == 0 ? ' (Free)' : '')} x {GetNumberOfMemberSelected(newMemberSelected) + newPublicParticipants.length}</span>
                    </div>
                    <div className='join-form-payment-row'>
                        <span className='join-form-payment-row-lbl'>Total</span>
                        <span className='join-form-payment-row-lbl'>RM {CalculatePriceTotal().toFixed(2)}</span>
                    </div>
                </div> ---temporary hide*/}
                <div className='join-form-col'>
                    {/*<button className='join-form-btn' onClick={() => OnProceedToPaymentClicked()}>Proceed To Payment</button>
                    {
                        eventRate > 0 ?
                            <button className='join-form-btn' onClick={() => OnGenerateInvoiceClicked()}>Generate Invoice</button>
                            :
                            <button className='join-form-btn' onClick={() => OnGenerateInvoiceClicked()}>Submit Registration</button>
                    } --hide*/}
                    {/* <button className='join-form-btn' onClick={() => OnSubmitRegistrationClicked()}>Submit Registration</button> ---deprecated */}
                    <button className='join-form-btn' onClick={() => OnRegistrationProceedClicked()}>Next</button>
                </div>
                {
                    shouldShowAddPublicParticipantMenu ?
                        RenderAddPublicParticipantMenu()
                        :
                        null
                }
                {
                    shouldShowUploadIdentificationDocumentsMenu ?
                        RenderUploadIdentificationDocumentsMenu()
                        :
                        null
                }
                {
                    shouldShowDietaryMenu ?
                        RenderDietaryMenu()
                        :
                        null
                }
            </div>
        )
    }
    const RenderUploadIdentificationDocumentsMenu = () => {
        let indexCount = 0;
        return (
            <div className='identification-documents-menu-block'>
                <div className='bg-ui-mask' />
                <div className='identification-documents-menu'>
                    <span className='identification-documents-menu-title'>Passport & NRIC photos are required for all participants:</span>
                    <div className='identification-documents-menu-scroll'>
                        {
                            newMemberSelected.map((selected: Boolean, i: number) => {
                                if (selected) {
                                    indexCount += 1;
                                    const memberDocIndex = GetMemberDocIndexByMemberIndex(i);
                                    return (
                                        <div className='menu-row' key={'menu-row-' + i}>
                                            <span className='menu-row-lbl ex'>{(indexCount).toString()}.</span>
                                            <span className='menu-row-lbl'>{exAppContext.membershipUsers[i].name}</span>
                                            {
                                                newMemberDocs[memberDocIndex].ic_fileName == '' ?
                                                    <button className='menu-row-btn' onClick={() => OnUploadDocumentClicked('member', 'nric', memberDocIndex)}>{'upload\nnric'}</button>
                                                    :
                                                    <div className='doc-preview-block'>
                                                        <img className='doc-preview-block-img' src={"data:image/jpeg;base64," + newMemberDocs[memberDocIndex].ic_base64String} />
                                                        <button className='doc-preview-remove-btn' onClick={() => OnRemoveDocumentClicked('member', 'nric', i)}><RemoveIcon /></button>
                                                    </div>
                                            }
                                            {
                                                newMemberDocs[memberDocIndex].passport_filaName == '' ?
                                                    <button className='menu-row-btn' onClick={() => OnUploadDocumentClicked('member', 'passport', memberDocIndex)}>{'upload\npassport'}</button>
                                                    :
                                                    <div className='doc-preview-block'>
                                                        <img className='doc-preview-block-img' src={"data:image/jpeg;base64," + newMemberDocs[memberDocIndex].passport_base64String} />
                                                        <button className='doc-preview-remove-btn' onClick={() => OnRemoveDocumentClicked('member', 'passport', memberDocIndex)}><RemoveIcon /></button>
                                                    </div>
                                            }
                                        </div>
                                    )
                                } else {
                                    return null;
                                }
                            })
                        }
                        {
                            newPublicParticipants.map((publicUser: PublicUser, i: number) => {
                                indexCount += 1;
                                return (
                                    <div className='menu-row' key={'menu-row-' + i}>
                                        <span className='menu-row-lbl ex'>{(indexCount).toString()}.</span>
                                        <span className='menu-row-lbl'>{publicUser.fullname}</span>
                                        {
                                            newPublicDocs[i].ic_fileName == '' ?
                                                <button className='menu-row-btn' onClick={() => OnUploadDocumentClicked('public', 'nric', i)}>{'upload\nnric'}</button>
                                                :
                                                <div className='doc-preview-block'>
                                                    <img className='doc-preview-block-img' src={"data:image/jpeg;base64," + newPublicDocs[i].ic_base64String} />
                                                    <button className='doc-preview-remove-btn' onClick={() => OnRemoveDocumentClicked('public', 'nric', i)}><RemoveIcon /></button>
                                                </div>
                                        }
                                        {
                                            newPublicDocs[i].passport_filaName == '' ?
                                                <button className='menu-row-btn' onClick={() => OnUploadDocumentClicked('public', 'passport', i)}>{'upload\npassport'}</button>
                                                :
                                                <div className='doc-preview-block'>
                                                    <img className='doc-preview-block-img' src={"data:image/jpeg;base64," + newPublicDocs[i].passport_base64String} />
                                                    <button className='doc-preview-remove-btn' onClick={() => OnRemoveDocumentClicked('public', 'passport', i)}><RemoveIcon /></button>
                                                </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='identification-documents-menu-option-panel'>
                        <button className='identification-documents-menu-option-btn ex' onClick={() => SetShouldShowUploadIdentificationDocumentsMenu(false)}>Back</button>
                        <button className='identification-documents-menu-option-btn' onClick={() => SetShouldShowDietaryMenu(true)} disabled={!IsAllIdentificationDocsUploaded()}>Next</button>
                    </div>
                </div>
            </div>
        );
    }
    const RenderDietaryMenu = () => {
        let indexCount = 0;
        return (
            <div className='dietary-menu-block'>
                <div className='bg-ui-mask' />
                <div className='dietary-menu'>
                    <span className='dietary-menu-title'>Select Dietary Preferences:</span>
                    <div className='dietary-menu-scroll'>
                        {
                            newMemberSelected.map((selected: Boolean, i: number) => {
                                if (selected) {
                                    indexCount += 1;
                                    return (
                                        <div className='menu-row' key={'menu-row-' + i}>
                                            <span className='menu-row-lbl ex'>{indexCount.toString()}.</span>
                                            <span className='menu-row-lbl'>{exAppContext.membershipUsers[i].name}</span>
                                            <div className='menu-row-select'>
                                                <SelectionBox selectionList={nonstate.dietaryOptionSelectionList} selectingKey={GetDietaryOptionByUser(exAppContext.membershipUsers[i].nric)} SetSelectingKey={(value: string) => UpdateDietaryOptionByUser(value, exAppContext.membershipUsers[i].nric)} />
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return null;
                                }
                            })
                        }
                        {
                            newPublicParticipants.map((publicUser: PublicUser, i: number) => {
                                indexCount += 1;
                                return (
                                    <div className='menu-row' key={'menu-row-' + i}>
                                        <span className='menu-row-lbl ex'>{indexCount.toString()}.</span>
                                        <span className='menu-row-lbl'>{publicUser.fullname}</span>
                                        <div className='menu-row-select'>
                                            <SelectionBox selectionList={nonstate.dietaryOptionSelectionList} selectingKey={GetDietaryOptionByUser(newPublicParticipants[i].id)} SetSelectingKey={(value: string) => UpdateDietaryOptionByUser(value, newPublicParticipants[i].id)} />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='dietary-menu-option-panel'>
                        <button className='dietary-menu-option-btn ex' onClick={() => SetShouldShowDietaryMenu(false)}>Back</button>
                        <button className='dietary-menu-option-btn' onClick={() => OnSubmitRegistrationClicked()}>Submit Registration</button>
                    </div>
                </div>
            </div>
        );
    }
    const RenderFormMemberBlock = (member: MemberUser, i: number) => {
        return (
            <div className='join-form-member-block' key={'join-form-member-block-' + i}>
                {
                    member.profile_image.length > 0 ?
                        <img className='member-block-img' src={member.profile_image} />
                        :
                        <AccountCircleIcon />
                }
                <div className='member-block-col'>
                    <span className='member-block-title'>{member.name}</span>
                    <span className='member-block-lbl'>{member.email}</span>
                </div>
                <Checker label='' checked={IsAlreadyRegistered(member) ? true : newMemberSelected[i]} SetChecked={() => OnSelectUnSelectMember(i)} disabled={IsAlreadyRegistered(member)} />
            </div>
        )
    }
    const RenderFormPublicParticipantBlock = (publicParticipant: PublicUser, i: number, disabled: boolean = false) => {
        return (
            <div className='join-form-public-user-block' key={'join-form-public-user-block' + i}>
                <span className='join-form-public-user-no'>{(i + 1).toString()}</span>
                <div className='public-user-block-col'>
                    <span className='public-user-block-title'>{publicParticipant.fullname}</span>
                    <span className='public-user-block-lbl'>{publicParticipant.email}</span>
                </div>
                <div className='public-user-block-col ex'>
                    <span className='public-user-block-title'>{publicParticipant.id}</span>
                    <span className='public-user-block-lbl'>{'+' + publicParticipant.phone}</span>
                </div>
                <button className='public-user-block-btn' onClick={() => OnRemovePublicUserClicked(i)} disabled={disabled}><RemoveIcon /></button>
            </div>
        )
    }
    const RenderAddPublicParticipantMenu = () => {
        return (
            <div className='add-public-participant-menu-block'>
                <div className='ui-block-screen' />
                <div className='add-public-participant-menu'>
                    <div className='add-public-participant-menu-scroll'>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>Salutation</span>
                            {/* <div className='add-public-participant-menu-select'>
                                <SelectionBox selectingKey={newPublicUserSalutation.toString()} SetSelectingKey={SetNewPublicUserSalutation} selectionList={nonstate.salutationSelectionList} />
                            </div> */}
                            <input className='add-public-participant-menu-in' value={newPublicUserSalutation} onChange={(e: any) => SetNewPublicUserSalutation(e.target.value.replace(/[^a-zA-Z ]/g, ''))} placeholder='e.g. Mr'/>
                        </div>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>Full Name (as per NRIC) *</span>
                            <input className='add-public-participant-menu-in' value={newPublicUserFullName} onChange={(e: any) => SetNewPublicUserFullName(e.target.value.replace(/,/g, ''))} placeholder='e.g. Olivia Wilson' />
                        </div>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>NRIC No. *</span>
                            <input className='add-public-participant-menu-in' value={FormatIcNo(newPublicUserIC)} onChange={(e: any) => SetNewPublicUserIC(e.target.value.replace(/[A-Za-z\-\,]/g, '').substring(0, 12))} placeholder='xxxxxx-xx-xxxx' onBlur={(e: any) => OnAddPublicParticipantNRIC(e.target.value)} />
                        </div>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>Email *</span>
                            <input className='add-public-participant-menu-in' value={newPublicUserEmail} onChange={(e: any) => SetNewPublicUserEmail(e.target.value.replace(/\,/g, ''))} placeholder='example@gmail.com' onBlur={(e: any) => OnAddPublicParticipantEmail(e.target.value)} />
                        </div>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>Phone No. *</span>
                            <input className='add-public-participant-menu-in' value={'+60 ' + FormatPhoneNumber(newPublicUserPhone, '60')} onChange={(e: any) => SetNewPublicUserPhone(e.target.value.replace(/[A-Za-z\+\s\,]/g, ''))} placeholder='+60-19xxxxxxx' onBlur={(e: any) => OnAddPublicParticipantPhone(e.target.value)} />
                        </div>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>Designation *</span>
                            <input className='add-public-participant-menu-in' value={newPublicUserDesignation} onChange={(e: any) => SetNewPublicUserDesignation(e.target.value)} placeholder='Company Staff' />
                        </div>
                        <div className='add-public-participant-menu-row'>
                            <span className='add-public-participant-menu-title'>RPM No.</span>
                            <input className='add-public-participant-menu-in' value={newPublicUserRPMNo} onChange={(e: any) => SetNewPublicUserRPMNo(e.target.value)} placeholder='xxxx' />
                        </div>
                        <button className='add-public-participant-menu-btn' onClick={() => OnAddPublicParticipantClicked()}>Add This Participant</button>
                    </div>
                    <button className='add-public-participant-close-btn' onClick={() => { ResetAddPublicParticipantFormVariables(); SetShouldShowAddPublicParticipantMenu(false); }}><CloseIcon /></button>
                </div>
            </div>
        )
    }
    const RenderEventPayment = () => {
        return (
            <div className='payment'>
                <button className='payment-btn' onClick={() => OnPayBtnClicked()}>Pay</button>
            </div>
        )
    }
    const RenderInvoiceComplete = () => {
        return (
            <div className='invoice-complete'>
                <div className='invoice-complete-menu'>
                    <VerifiedIcon />
                    {/* {
                        eventRate > 0 ?
                            <span className='invoice-complete-lbl'>Your invoice has been successfully generated.<br /><br /><br />
                                <span className='invoice-complete-lbl warning'>Kindly complete your payment within 14 days to avoid the cancellation of your registration.</span>
                            </span>
                            :
                            <span className='invoice-complete-lbl'>You have successfully<br />registered an event.<br /><br /><br />
                                <span className='invoice-complete-lbl warning'>You are able to view your<br />tickets at "My Events".</span>
                            </span>
                    } */}
                    <span className='invoice-complete-lbl'>You have successfully<br />registered an event.<br /><br />PPK Secretariat will be in contact soon regarding your payment documentations.</span>
                    <div className='invoice-complete-option-panel'>
                        <button className='invoice-complete-option-btn' onClick={() => history.push('/EventRegistrations')}>View Registration</button>
                        <button className='invoice-complete-option-btn' onClick={() => { pageRef.current = Events_PageMap.UPCOMING; SetPage(pageRef.current); }}>More Events</button>
                        {/* <button className='invoice-complete-option-btn' onClick={() => history.push('/Home')}>Back To Home</button> */}
                    </div>
                </div>
            </div>
        );
    }
    const RenderEventCard = (event: Event, i: number) => {
        return (
            <div className='event-card' key={'event-card-' + i}>
                {
                    page == Events_PageMap.UPCOMING ?
                        (
                            upcomingEventsAltImgsErr[i] != undefined && upcomingEventsAltImgsErr[i] ?
                                <img className='event-card-img' src={DefaultImage} />
                                :
                                <img className='event-card-img' src={event.event_poster} onError={() => {
                                    setTimeout(() => {
                                        upcomingEventsAltImgsErrRef.current[i] = true;
                                        SetUpcomingEventsAltImgsErr([...upcomingEventsAltImgsErrRef.current]);
                                    }, 10 + Math.random() * 500);
                                }} />
                        )
                        :
                        (
                            page == Events_PageMap.PAST ?
                                (
                                    pastEventsAltImgsErr[i] != undefined && pastEventsAltImgsErr[i] ?
                                        <img className='event-card-img' src={DefaultImage} />
                                        :
                                        <img className='event-card-img' src={event.event_poster} onError={() => {
                                            setTimeout(() => {
                                                pastEventsAltImgsErrRef.current[i] = true;
                                                SetPastEventsAltImgsErr([...pastEventsAltImgsErrRef.current]);
                                            }, 10 + Math.random() * 500);
                                        }} />
                                )
                                :
                                null
                        )
                }
                <div className={'event-card-col'}>
                    <div className='event-card-title' dangerouslySetInnerHTML={{ __html: ConstructEventNameHtml(event.event_name, event.event_name_highlight_texts, event.event_name_highlight_colors) }}></div>
                    {/* <span className='event-card-title'>{event.event_name}</span> ---deprecated */}
                    <div className='event-card-row'>
                        <LocationOnIcon />
                        <span className='event-card-lbl'>{event.event_venue}</span>
                    </div>
                    <div className='event-card-row'>
                        <DateRangeIcon />
                        <span className='event-card-lbl'>{IonDateString(event.event_start_date, IonDateFormat.LONG_DATE)} - {IonDateString(event.event_end_date, IonDateFormat.LONG_DATE)}</span>
                    </div>
                </div>
                <div className='background-ui-mask' onClick={() => SetCurrentSelectedEvent(event)} />
                {/* <div className='event-card-option-panel'>
                    <button className='event-card-option-btn' onClick={() => SetCurrentSelectedEvent(event)}>Event Details<ArrowForwardIosIcon /></button>
                </div> */}
            </div>
        )
    }

    //exe functions
    const GetKeyOfObjectByValue = (obj: any, value: any) => {
        let res = '';
        Object.keys(obj).map((key: string) => {
            if (obj[key] == value)
                res = key;
        });
        return res;
    }
    const SortEventsByDate = (events: Event[], mode: number) => {
        const sorted = [] as Event[];
        events.map((event: Event) => {
            let isSorted = false;
            sorted.map((sort: Event, i: number) => {
                if (!isSorted &&
                    (event.event_start_datetime! && sort.event_start_datetime!) &&
                    (
                        mode == Events_SortModeMap.DESCENDING ?
                            event.event_start_datetime > sort.event_start_datetime
                            :
                            event.event_start_datetime < sort.event_start_datetime
                    )
                ) {
                    sorted.splice(i, 0, event);
                    isSorted = true;
                }
            });
            if (!isSorted)
                sorted.push(event);
        });
        return sorted;
    }
    const RefetchOngoingEvents = () => {
        databaseInterfaceController.Queue('fetchOngoingEvents', [
            ['fetchOngoingEvents', 'true'],
            ['dateTimeNow', IonDateString(new Date())]
        ]);
    }
    const RefetchPastEvents = () => {
        pastEventsBatchFetchCountRef.current = 0;
        eventScrollCheckRef.current = true;

        SetPastEvents([] as Event[]);

        requestAnimationFrame(() => {
            databaseInterfaceController.Queue('fetchPastEventsByBatch', [
                ['fetchPastEventsByBatch', 'true'],
                ['dateNow', IonDateString(new Date())],
                ['offset', pastEventsBatchFetchCountRef.current * nonstate.eventFetchBatchSize],
                ['limit', nonstate.eventFetchBatchSize]
            ]);
        });
    }
    // const FetchMemberUsersOfEvent = () => {
    //     databaseInterfaceController.Queue('fetchMemberUsersOfEvent', [
    //         ['fetchMemberUsersOfEvent', 'true'],
    //         ['memberID', appContext.user.memberID],
    //         ['eventID', currentSelectedEvent.eventID]
    //     ]);
    // } ---deprecated, exAppContext.membershipUsers
    const GetMembersSelectedCount = (_newMemberSelected: boolean[]) => {
        let count = 0;
        _newMemberSelected.map((selected: boolean) => {
            if (selected)
                count += 1;
        });
        return count;
    }
    const CalculatePriceTotal = (): number => {
        return eventRate * (GetNumberOfMemberSelected(newMemberSelected) + newPublicParticipants.length);
    }
    const ResetFormVariables = () => {
        //billing info
        SetNewBillingName(/*IsNotAssociateMember() --deprecated*/IsCorporate() ? exAppContext.membership.company_name : appContext.user.name);
        SetNewBillingAddress(/*IsNotAssociateMember() ---deprecated*/IsCorporate() ? exAppContext.membership.correspondence_address : appContext.user.address);
        SetNewEInvoicePin(/*IsNotAssociateMember() --deprecated*/IsCorporate() ? exAppContext.membership.e_invoice_pin : '');
        //contact person info
        SetNewContactSalutation('Mr');
        SetNewContactOtherSalutation(appContext.user.other_salutation);
        SetNewContactName(appContext.user.name);
        SetNewContactEmail(appContext.user.email);
        SetNewCountryCode(appContext.user.handphone_code);
        SetNewContactPhone(appContext.user.handphone_no);
        SetNewContactOfficeNo(appContext.user.office_tel_no);
        //participant info
        const _newMemberSelected = [] as boolean[];
        newMemberSelected.map(() => {
            _newMemberSelected.push(false);
        });
        SetNewMemberSelected([..._newMemberSelected]);
        SetNewPublicParticipants([]);
        SetShouldShowDietaryMenu(false);
    }
    const ResetAddPublicParticipantFormVariables = () => {
        SetNewPublicUserSalutation('Mr');
        SetNewPublicUserFullName('');
        SetNewPublicUserIC('');
        SetNewPublicUserEmail('');
        SetNewPublicUserPhone('');
        SetNewPublicUserDesignation('');
        SetNewPublicUserRPMNo('');
    }
    const GetNumberOfMemberSelected = (memberSelection: boolean[]) => {
        let count = 0;
        memberSelection.map((selection: boolean) => {
            if (selection)
                count += 1;
        });
        return count;
    }
    const GenerateBeneficiaryIDs = () => {
        const selectedUserIDs = [] as string[];
        exAppContext.membershipUsers.map((member: MemberUser, i: number) => {
            if (newMemberSelected[i] == true)
                selectedUserIDs.push(member.userID);
        });
        return selectedUserIDs.join(',');
    }
    const GeneratePublicBeneficiaryDetails = (mode: number) => {
        const res = [] as string[];
        switch (mode) {
            case Events_PublicBeneficiaryMode.ID:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.id);
                });
                break;
            case Events_PublicBeneficiaryMode.SALUTATION:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.salutation);
                });
                break;
            case Events_PublicBeneficiaryMode.FULL_NAME:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.fullname);
                });
                break;
            case Events_PublicBeneficiaryMode.EMAIL:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.email);
                });
                break;
            case Events_PublicBeneficiaryMode.PHONE:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.phone);
                });
                break;
            case Events_PublicBeneficiaryMode.DESIGNATION:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.designation);
                });
                break;
            case Events_PublicBeneficiaryMode.RPM_NO:
                newPublicParticipants.map((participant: PublicUser) => {
                    res.push(participant.rpmNo);
                });
                break;
        }
        return res.join(',');
    }
    const InitializeCountryCodesSelectionList = () => {
        const list = [] as SelectionList[];
        list.push({
            key: "60",
            value: "(60) Malaysia"
        } as SelectionList)
        Country.getAllCountries().map((country: any) => {
            if (country.phonecode != '60') {
                list.push({
                    key: country.phonecode,
                    value: "(" + country.phonecode + ") " + country.name
                } as SelectionList);
            }
        });
        SetSelectionList_countryCode([...list]);
    }
    const FormatPhoneNumber = (phoneNo: string, countryCode: string) => {
        if (phoneNo.substring(0, 2) == countryCode)
            return phoneNo.substring(2);
        else if (phoneNo.substring(0, 1) == countryCode.substring(countryCode.length - 1))
            return phoneNo.substring(1);
        else
            return phoneNo;
    }
    const FormatIcNo = (icNo: string) => {
        let res = icNo.substring(0, 6);
        if (icNo.length >= 6) {
            res += '-' + icNo.substring(6, 8);
        }
        if (icNo.length >= 8) {
            res += '-' + icNo.substring(8, 12);
        }
        return res;
    }
    const FilterEventsBySearchString = (events: Event[]) => {
        let filtered = [] as Event[];
        if (filter_searchString != '') {
            events.map((event: Event) => {
                if (
                    event.event_name.toUpperCase().includes(filter_searchString.toUpperCase())
                ) {
                    filtered.push(event);
                }
            });
        } else
            filtered = events;
        return filtered;
    }
    const FilterEventsByCategory = (events: Event[]) => {
        let filtered = [] as Event[];
        if (filter_eventCategory != '') {
            events.map((event: Event) => {
                if (event.event_categoryID == filter_eventCategory)
                    filtered.push(event);
            });
        } else {
            filtered = events;
        }
        return filtered;
    }
    const GetTotalAttemptedParticipants = () => {
        let res = 0;
        newMemberSelected.map((selected: Boolean) => {
            if (selected)
                res += 1;
        });
        res += newPublicParticipants.length;
        return res;
    }
    const SaveBlobToCache = async (blob: Blob) => {
        try {
            // Convert the Blob to a Uint8Array
            //   const arrayBuffer = await blob.arrayBuffer();
            // //   const uint8Array = new Uint8Array(arrayBuffer);
            BlobToBase64(blob).then(async (base64String: any) => {
                // Define the file name and path
                const filePath = `invoice.pdf`;

                // Write the file to the Cache directory
                const writeResult = await Filesystem.writeFile({
                    path: filePath,
                    data: base64String,
                    directory: Directory.Cache,
                });

                FileOpener.open({
                    filePath: writeResult.uri,
                    contentType: 'application/pdf',
                    openWithDefault: true
                });
                return writeResult.uri;  // Return the file URI (path to the saved file)
            }).catch((err: string) => { console.log('BlobToBase64Err: ' + err); });
        } catch (error) {
            console.error('Error saving Blob to cache:', error);
        }
    }
    const BlobToBase64 = (blob: Blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            // When the file is loaded, resolve the promise with the base64 string
            reader.onloadend = () => {
                resolve(reader.result); // This is the base64 string
            };

            // Handle any errors that occur during the read operation
            reader.onerror = (error) => {
                reject(error);
            };

            // Read the blob as a data URL (base64)
            reader.readAsDataURL(blob);
        });
    }
    const GetFormFillRequiredMessage = () => {
        /**
         *  newBillingName.length >= 3
            && newBillingAddress.length >= 3
            && newEInvoicePin.length >= 3
            && newContactName.length >= 3
            && newContactEmail.length >= 3
            && newContactPhone.length >= 3
         */
        if (newBillingName.length < 3) {
            return 'You are required to fill in valid Billing Name.';
        } else if (newBillingAddress.length < 3) {
            return 'You are required to fill in valid Billing Address.';
        } else if (newContactName.length < 3) {
            return 'You are required to fill in valid Contact Person Name.';
        } else if (newContactEmail.length < 3) {
            return 'You are required to fill in valid Contact Person Email Address.';
        } else if (newContactPhone.length < 3) {
            return 'You are required to fill in valid Contact Person Mobile No.';
        } else if (newContactOfficeNo.length < 3) {
            return 'You are required to fill in valid Office No.';
        } else {
            return 'You are required to fill in all fields marked (*)';
        }
    }
    const ResetPastEventScrollHandler = () => {
        SetPastEvents([] as Event[]);
        eventScrollRef.current.removeEventListener('scroll', pastEventScrollActionRef.current);
        requestAnimationFrame(() => {
            eventScrollRef.current.addEventListener('scroll', pastEventScrollActionRef.current);
            eventScrollCheckRef.current = true;
        });
    }
    const ConstructEventNameHtml = (eventName: string, highlightTexts: string[], highlightColors: string[]) => {
        let res = eventName;

        highlightTexts.map((text: string, i: number) => {
            const regex = new RegExp(text, 'g');
            res = res.replace(regex, '<span style="color: ' + '#' + highlightColors[i] + '">' + text + '</span>');
        });

        return res;
    }
    const GetDietaryOptionByUser = (nric: string) => {
        //check in memberUsers
        let indexCount = 0; let userFound = false;
        let res = '';
        newMemberSelected.map((selected: boolean, i: number) => {
            if (selected) {
                if (!userFound && exAppContext.membershipUsers[i].nric == nric) {
                    res = newMemberDietaryOptions[indexCount].toString();
                    userFound = true;
                }
                indexCount += 1;
            }
        });
        //check in public beneficials
        if (!userFound) {
            newPublicParticipants.map((publicUser: PublicUser, i: number) => {
                if (publicUser.id == nric) {
                    res = newPublicDietaryOptions[i].toString();
                    userFound = true;
                }
                indexCount += 1;
            });
        }
        return res;
    }
    const UpdateDietaryOptionByUser = (value: string, nric: string) => {
        let indexCount = 0; let userFound = false;
        //search through memberUsers for nric
        newMemberSelected.map((selected: boolean, i: number) => {
            if (selected) {
                if (!userFound && exAppContext.membershipUsers[i].nric == nric) {
                    const _newMemberDietaryOptions = newMemberDietaryOptions;
                    _newMemberDietaryOptions[indexCount] = parseInt(value);
                    SetNewMemberDietaryOptions([..._newMemberDietaryOptions]);
                    userFound = true;
                }
                indexCount += 1;
            }
        });

        if (!userFound) {
            indexCount = 0;
            //search through publicBeneficialNric
            newPublicParticipants.map((publicUser: PublicUser) => {
                if (!userFound && publicUser.id == nric) {
                    const _newPublicDietaryOptions = newPublicDietaryOptions;
                    _newPublicDietaryOptions[indexCount] = parseInt(value);
                    SetNewPublicDietaryOptions([..._newPublicDietaryOptions]);
                    userFound = true;
                }
                indexCount += 1;
            });
        }
    }
    const ResizeImage = (imgUrl: string, userType: string, documentType: string, index: number) => {
        canvasRef.current = document.createElement('canvas');

        //process image
        if (imgUrl != '') {
            imageRef.current.src = imgUrl;
            imageRef.current.onload = () => {


                //get image profile
                let [orientation, naturalWidth, naturalHeight, w_h_ratio] = GetImageProfile(imageRef.current);
                if (canvasRef.current != undefined) {
                    canvasRef.current.width = nonstate.controlledImgSize;
                    canvasRef.current.height = Math.floor(nonstate.controlledImgSize / w_h_ratio);
                    let context = canvasRef.current.getContext('2d');
                    if (context) {
                        context.drawImage(
                            imageRef.current,
                            0, 0,
                            naturalWidth, naturalHeight,
                            0, 0, //start draw from canvas pos 
                            canvasRef.current.width, canvasRef.current.height //draw till canvas dimension);
                        );
                    }
                    if (canvasRef.current) {
                        switch (userType) {
                            case 'member':
                                const memberUser = GetSelectedMemberByIndex(index);
                                if (memberUser != null) {
                                    if (documentType == 'nric') {
                                        newMemberDocsRef.current[index] = new IdentificationDocument(
                                            memberUser.name.replace(/\s/g, '_') + '_nric.jpeg',
                                            canvasRef.current.toDataURL().split(',')[1],
                                            newMemberDocsRef.current[index].passport_filaName,
                                            newMemberDocsRef.current[index].passport_base64String
                                        );
                                    } else if (documentType == 'passport') {
                                        newMemberDocsRef.current[index] = new IdentificationDocument(
                                            newMemberDocsRef.current[index].ic_fileName,
                                            newMemberDocsRef.current[index].ic_base64String,
                                            memberUser.name.replace(/\s/g, '_') + '_passport.jpeg',
                                            canvasRef.current.toDataURL().split(',')[1]
                                        );
                                    }
                                }
                                SetNewMemberDocs([...newMemberDocsRef.current]);
                                break;
                            case 'public':
                                const publicUser = newPublicParticipants[index];
                                if (documentType == 'nric') {
                                    newPublicDocsRef.current[index] = new IdentificationDocument(
                                        publicUser.fullname.replace(/\s/g, '_') + '_nric.jpeg',
                                        canvasRef.current.toDataURL().split(',')[1],
                                        newPublicDocsRef.current[index].passport_filaName,
                                        newPublicDocsRef.current[index].passport_base64String
                                    );
                                } else if (documentType == 'passport') {
                                    newPublicDocsRef.current[index] = new IdentificationDocument(
                                        newPublicDocsRef.current[index].ic_fileName,
                                        newPublicDocsRef.current[index].ic_base64String,
                                        publicUser.fullname.replace(/\s/g, '_') + '_passport.jpeg',
                                        canvasRef.current.toDataURL().split(',')[1]
                                    );
                                }
                                SetNewPublicDocs([...newPublicDocsRef.current]);
                                break;
                        }
                        // SetNewProfileImgBase64(canvasRef.current.toDataURL().split(',')[1]);
                    }
                }
            }
        }
        return '';
    }
    const GetImageProfile = (image: HTMLImageElement): [string, number, number, number] => {

        let orientation: string = '';
        // let grabSize: number = 0;
        // let grabOffset: number = 0;
        let naturalWidth = image.naturalWidth;
        let naturalHeight = image.naturalHeight;
        let w_h_ratio = naturalWidth / naturalHeight;

        if (naturalHeight >= naturalWidth) {
            //is a portrait or square
            orientation = 'portrait';
            // grabSize = image.width;
            // grabOffset = (image.height - image.width) / 2;
        } else {
            //is a landscape
            orientation = 'landscape';
        }

        return [orientation, naturalWidth, naturalHeight, w_h_ratio];
    }
    const GetSelectedMemberByIndex = (index: number) => {
        const selectedMember = [] as MemberUser[];
        newMemberSelected.map((selected: boolean, i: number) => {
            if (selected)
                selectedMember.push(exAppContext.membershipUsers[i]);
        });

        if (index < selectedMember.length)
            return selectedMember[index];
        else
            return null;
    }
    const GetMemberDocIndexByMemberIndex = (index: number) => {
        let res = 0;
        const selectedMemberIndex = [] as number[];
        newMemberSelected.map((selected: boolean, i: number) => {
            if (selected)
                selectedMemberIndex.push(i);
        });

        selectedMemberIndex.map((_index: number, i: number) => {
            if (index == _index)
                res = i;
        });
        return res;
    }

    //check functions
    const IsUpcomingEvent = (event: Event) => {
        let res = false;
        upcomingEvents.map((upcomingEvent: Event) => {
            if (event.eventID == upcomingEvent.eventID)
                res = true;
        });
        return res;
    }
    const IsRegistrationOpen = (event: Event) => {
        const dateNow = new Date();
        if (
            event.registration_start_date != null
            && event.registration_end_date != null
            && (dateNow >= event.registration_start_date && dateNow <= event.registration_end_date)
        ) {
            return true;
        } else
            return false;
    }
    const IsRegistrationOver = (event: Event) => {
        const dateNow = new Date();
        if (
            event.registration_end_date != null
            && (dateNow > event.registration_end_date)
        ) {
            return true;
        } else
            return false;
    }
    const IsTTTEvent = () => {
        if(currentSelectedEvent.event_categoryID == '10') {
            return true;
        } else
            return false;
    }
    // const IsNotAssociateMember = () => {
    //     let res = true;
    //     exAppContext.memberTypes.map((memberType: MemberType) => {
    //         if (memberType.label.toLocaleLowerCase() == 'associate' && memberType.member_typeID == exAppContext.membership.member_typeID)
    //             res = false;
    //     });
    //     return res;
    // } --deprecate to IsCorporate
    const IsCorporate = () => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                exAppContext.membership.member_typeID == memberType.member_typeID
                && memberType.label.toLowerCase().includes('corporate')
            ) {
                res = true;
            }
        });
        return res;
    }
    const IsAlreadyRegistered = (memberUser?: MemberUser, publicBeneficiaryID?: string) => {
        let res = false;
        if (
            selectedEventRegistrations.length > 0
            && (memberUser != undefined || publicBeneficiaryID != undefined)
        ) {
            selectedEventRegistrations.map((registration: EventRegistration) => {
                if (memberUser != undefined) {
                    if (registration.beneficiaryIDs.join(',').includes(memberUser.userID)) {
                        res = true;
                    }
                } else if (publicBeneficiaryID != undefined) {
                    if (registration.public_beneficiary_ids.includes(publicBeneficiaryID)) {
                        res = true;
                    }
                }
            });
        }
        return res;
    }
    const IsStudyTrip = () => {
        let res = false;
        exAppContext.eventCategories.map((eventCategory: EventCategory) => {
            if (eventCategory.event_categoryID == currentSelectedEvent.event_categoryID) {
                if (eventCategory.event_category_name.toLowerCase().includes('study trip')) {
                    res = true;
                }
            }
        });

        return res;
    }
    const IsAllIdentificationDocsUploaded = () => {
        let res = true;
        newMemberDocs.map((doc: IdentificationDocument) => {
            if (doc.ic_fileName == '' || doc.passport_filaName == '') {
                res = false;
            }
        });
        newPublicDocs.map((doc: IdentificationDocument) => {
            if (doc.ic_fileName == '' || doc.passport_filaName == '') {
                res = false;
            }
        });
        return res;
    }

    return (
        <div className={'Events ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='option-panel'>
                {RenderTopOptions()}
                {RenderBottomOptions()}
            </div>
            {
                RenderPages()
            }
            {/** swipe overscroll handlers */}
            <SwipeOverscrollHandler targetRef={eventScrollRef} action={() => {
                if (pageRef.current == Events_PageMap.UPCOMING)
                    RefetchOngoingEvents();
                else if (pageRef.current == Events_PageMap.PAST)
                    RefetchPastEvents();
            }} />
        </div>
    )
}
export default Events;